[
  {
    "id": "ai-search-bot",
    "category": "AI_CRAWLER",
    "name": "ai-search-bot",
    "patterns": [
      "AISearchBot"
    ],
    "forbidden": []
  },
  {
    "id": "ai2-crawler",
    "category": "AI_CRAWLER",
    "name": "ai2-crawler",
    "patterns": [
      "AI2Bot\\s"
    ],
    "forbidden": []
  },
  {
    "id": "ai2-crawler-dolma",
    "category": "AI_CRAWLER",
    "name": "ai2-crawler-dolma",
    "patterns": [
      "Ai2Bot-Dolma"
    ],
    "forbidden": []
  },
  {
    "id": "aihit-crawler",
    "category": "AI_CRAWLER",
    "name": "aihit-crawler",
    "patterns": [
      "aiHitBot"
    ],
    "forbidden": []
  },
  {
    "id": "anthropic-ai-token",
    "category": "AI_CRAWLER",
    "name": "Anthropic",
    "patterns": [
      "anthropic-ai"
    ],
    "forbidden": []
  },
  {
    "id": "anthropic-crawler",
    "category": "AI_CRAWLER",
    "name": "ClaudeBot",
    "patterns": [
      "[cC]laude(?:[bB]ot|-[Ww]eb)"
    ],
    "forbidden": []
  },
  {
    "id": "anthropic-crawler-search",
    "category": "AI_CRAWLER",
    "name": "ClaudeSearchBot",
    "patterns": [
      "Claude-SearchBot"
    ],
    "forbidden": []
  },
  {
    "id": "anthropic-crawler-user",
    "category": "AI_CRAWLER",
    "name": "ClaudeUser",
    "patterns": [
      "Claude-User"
    ],
    "forbidden": []
  },
  {
    "id": "botify-crawler",
    "category": "AI_CRAWLER",
    "name": "botify-crawler",
    "patterns": [
      "botify"
    ],
    "forbidden": []
  },
  {
    "id": "bytedance-crawler",
    "category": "AI_CRAWLER",
    "name": "Bytespider",
    "patterns": [
      "Bytespider"
    ],
    "forbidden": []
  },
  {
    "id": "ccbot-crawler",
    "category": "AI_CRAWLER",
    "name": "CCBot",
    "patterns": [
      "CCBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "cohere-crawler",
    "category": "AI_CRAWLER",
    "name": "cohere-crawler",
    "patterns": [
      "cohere-ai"
    ],
    "forbidden": []
  },
  {
    "id": "diffbot-crawler",
    "category": "AI_CRAWLER",
    "name": "diffbot-crawler",
    "patterns": [
      "Diffbot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "friendlycrawler",
    "category": "AI_CRAWLER",
    "name": "friendlycrawler",
    "patterns": [
      "FriendlyCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "glutenfreepleasure-crawler",
    "category": "AI_CRAWLER",
    "name": "glutenfreepleasure-crawler",
    "patterns": [
      "Gluten Free Crawler\\/"
    ],
    "forbidden": []
  },
  {
    "id": "imagesift-crawler",
    "category": "AI_CRAWLER",
    "name": "imagesift-crawler",
    "patterns": [
      "ImagesiftBot"
    ],
    "forbidden": []
  },
  {
    "id": "infegy-crawler",
    "category": "AI_CRAWLER",
    "name": "infegy-crawler",
    "patterns": [
      "collection@infegy\\.com"
    ],
    "forbidden": []
  },
  {
    "id": "integralads-crawler",
    "category": "AI_CRAWLER",
    "name": "integralads-crawler",
    "patterns": [
      "IAS crawler"
    ],
    "forbidden": []
  },
  {
    "id": "leadcrunch-crawler",
    "category": "AI_CRAWLER",
    "name": "leadcrunch-crawler",
    "patterns": [
      "CrunchBot"
    ],
    "forbidden": []
  },
  {
    "id": "mediatoolkit-crawler",
    "category": "AI_CRAWLER",
    "name": "mediatoolkit-crawler",
    "patterns": [
      "Mediatoolkitbot"
    ],
    "forbidden": []
  },
  {
    "id": "meta-externalagent",
    "category": "AI_CRAWLER",
    "name": "Meta AI",
    "patterns": [
      "meta-externalagent"
    ],
    "forbidden": []
  },
  {
    "id": "ntent-crawler",
    "category": "AI_CRAWLER",
    "name": "ntent-crawler",
    "patterns": [
      "NTENTbot"
    ],
    "forbidden": []
  },
  {
    "id": "omgili-crawler",
    "category": "AI_CRAWLER",
    "name": "omgili-crawler",
    "patterns": [
      "omgili"
    ],
    "forbidden": []
  },
  {
    "id": "openai-crawler",
    "category": "AI_CRAWLER",
    "name": "GPTBot",
    "patterns": [
      "GPTBot"
    ],
    "forbidden": []
  },
  {
    "id": "openai-crawler-user",
    "category": "AI_CRAWLER",
    "name": "ChatGPTUser",
    "patterns": [
      "ChatGPT-User"
    ],
    "forbidden": []
  },
  {
    "id": "perplexity-crawler",
    "category": "AI_CRAWLER",
    "name": "PerplexityBot",
    "patterns": [
      "PerplexityBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "perplexity-user",
    "category": "AI_CRAWLER",
    "name": "perplexity-user",
    "patterns": [
      "Perplexity-User\\/"
    ],
    "forbidden": []
  },
  {
    "id": "primal-crawler",
    "category": "AI_CRAWLER",
    "name": "primal-crawler",
    "patterns": [
      "Primalbot"
    ],
    "forbidden": []
  },
  {
    "id": "sbintuitions-bot",
    "category": "AI_CRAWLER",
    "name": "sbintuitions-bot",
    "patterns": [
      "SBIntuitionsBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "searchatlas-crawler",
    "category": "AI_CRAWLER",
    "name": "searchatlas-crawler",
    "patterns": [
      "SearchAtlas"
    ],
    "forbidden": []
  },
  {
    "id": "sentione-crawler",
    "category": "AI_CRAWLER",
    "name": "sentione-crawler",
    "patterns": [
      "SentiBot"
    ],
    "forbidden": []
  },
  {
    "id": "storygize-crawler",
    "category": "AI_CRAWLER",
    "name": "storygize-crawler",
    "patterns": [
      "StorygizeBot"
    ],
    "forbidden": []
  },
  {
    "id": "timpi-crawler",
    "category": "AI_CRAWLER",
    "name": "timpi-crawler",
    "patterns": [
      "Timpibot"
    ],
    "forbidden": []
  },
  {
    "id": "velen-crawler",
    "category": "AI_CRAWLER",
    "name": "velen-crawler",
    "patterns": [
      "VelenPublicWebCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "webzio-crawler-ai",
    "category": "AI_CRAWLER",
    "name": "webzio-crawler-ai",
    "patterns": [
      "webzio-extended"
    ],
    "forbidden": []
  },
  {
    "id": "you-crawler",
    "category": "AI_CRAWLER",
    "name": "you-crawler",
    "patterns": [
      "YouBot"
    ],
    "forbidden": []
  },
  {
    "id": "cypress",
    "category": "AUTOMATED",
    "name": "Cypress",
    "patterns": [
      "[Cc]ypress"
    ],
    "forbidden": []
  },
  {
    "id": "fake-msie6",
    "category": "AUTOMATED",
    "name": "Fake IE6",
    "patterns": [
      "MSIE 6\\.0"
    ],
    "forbidden": []
  },
  {
    "id": "headless-chrome",
    "category": "AUTOMATED",
    "name": "Headless Chrome",
    "patterns": [
      "HeadlessChrome"
    ],
    "forbidden": []
  },
  {
    "id": "javascript-phantom",
    "category": "AUTOMATED",
    "name": "PhantomJS",
    "patterns": [
      "PhantomJS"
    ],
    "forbidden": []
  },
  {
    "id": "playwright",
    "category": "AUTOMATED",
    "name": "Playwright",
    "patterns": [
      "[Pp]laywright"
    ],
    "forbidden": []
  },
  {
    "id": "puppeteer",
    "category": "AUTOMATED",
    "name": "Puppeteer",
    "patterns": [
      "[Pp]uppeteer"
    ],
    "forbidden": []
  },
  {
    "id": "selenium",
    "category": "AUTOMATED",
    "name": "Selenium",
    "patterns": [
      "[Ss]elenium"
    ],
    "forbidden": []
  },
  {
    "id": "webdriver",
    "category": "AUTOMATED",
    "name": "WebDriver",
    "patterns": [
      "[Ww]ebdriver"
    ],
    "forbidden": []
  },
  {
    "id": "amazon-route53-health-check",
    "category": "MONITORING",
    "name": "amazon-route53-health-check",
    "patterns": [
      "Amazon Route 53 Health Check Service"
    ],
    "forbidden": []
  },
  {
    "id": "azure-app-insights",
    "category": "MONITORING",
    "name": "azure-app-insights",
    "patterns": [
      "AppInsights"
    ],
    "forbidden": []
  },
  {
    "id": "betterstack-monitor",
    "category": "MONITORING",
    "name": "betterstack-monitor",
    "patterns": [
      "Better Stack"
    ],
    "forbidden": []
  },
  {
    "id": "betteruptime-monitor",
    "category": "MONITORING",
    "name": "betteruptime-monitor",
    "patterns": [
      "Better Uptime Bot"
    ],
    "forbidden": []
  },
  {
    "id": "brandverity-crawler",
    "category": "MONITORING",
    "name": "brandverity-crawler",
    "patterns": [
      "BrandVerity"
    ],
    "forbidden": []
  },
  {
    "id": "censys-inspect",
    "category": "MONITORING",
    "name": "censys-inspect",
    "patterns": [
      "CensysInspect\\/"
    ],
    "forbidden": []
  },
  {
    "id": "changedetection-crawler",
    "category": "MONITORING",
    "name": "changedetection-crawler",
    "patterns": [
      "changedetection"
    ],
    "forbidden": []
  },
  {
    "id": "checkly-monitor",
    "category": "MONITORING",
    "name": "checkly-monitor",
    "patterns": [
      "Checkly\\/"
    ],
    "forbidden": []
  },
  {
    "id": "cloudflare-healthchecks",
    "category": "MONITORING",
    "name": "cloudflare-healthchecks",
    "patterns": [
      "Cloudflare-Healthchecks"
    ],
    "forbidden": []
  },
  {
    "id": "cloudflare-security-center",
    "category": "MONITORING",
    "name": "cloudflare-security-center",
    "patterns": [
      "https:\\/\\/developers\\.cloudflare\\.com\\/security-center\\/"
    ],
    "forbidden": []
  },
  {
    "id": "cloudflare-ssl-detector",
    "category": "MONITORING",
    "name": "cloudflare-ssl-detector",
    "patterns": [
      "Cloudflare-SSLDetector"
    ],
    "forbidden": []
  },
  {
    "id": "cloudflare-traffic-manager",
    "category": "MONITORING",
    "name": "cloudflare-traffic-manager",
    "patterns": [
      "Cloudflare-Traffic-Manager"
    ],
    "forbidden": []
  },
  {
    "id": "datadog-monitor-synthetics",
    "category": "MONITORING",
    "name": "Datadog",
    "patterns": [
      "Datadog\\/{0,1}Synthetics"
    ],
    "forbidden": []
  },
  {
    "id": "deadlinkchecker",
    "category": "MONITORING",
    "name": "deadlinkchecker",
    "patterns": [
      "deadlinkchecker"
    ],
    "forbidden": []
  },
  {
    "id": "disqus-crawler",
    "category": "MONITORING",
    "name": "disqus-crawler",
    "patterns": [
      "Disqus"
    ],
    "forbidden": []
  },
  {
    "id": "dubbot-crawler",
    "category": "MONITORING",
    "name": "dubbot-crawler",
    "patterns": [
      "Dubbotbot"
    ],
    "forbidden": []
  },
  {
    "id": "dynatrace-monitor",
    "category": "MONITORING",
    "name": "dynatrace-monitor",
    "patterns": [
      "RuxitSynthetic"
    ],
    "forbidden": []
  },
  {
    "id": "freewebmonitoring-monitor",
    "category": "MONITORING",
    "name": "freewebmonitoring-monitor",
    "patterns": [
      "FreeWebMonitoring SiteChecker"
    ],
    "forbidden": []
  },
  {
    "id": "freshworks-monitor",
    "category": "MONITORING",
    "name": "freshworks-monitor",
    "patterns": [
      "FreshpingBot"
    ],
    "forbidden": []
  },
  {
    "id": "google-certificates-bridge",
    "category": "MONITORING",
    "name": "google-certificates-bridge",
    "patterns": [
      "Google-Certificates-Bridge"
    ],
    "forbidden": []
  },
  {
    "id": "google-site-verification",
    "category": "MONITORING",
    "name": "google-site-verification",
    "patterns": [
      "Google-Site-Verification"
    ],
    "forbidden": []
  },
  {
    "id": "google-structured-data-testing-tool",
    "category": "MONITORING",
    "name": "google-structured-data-testing-tool",
    "patterns": [
      "Google-Structured-Data-Testing-Tool"
    ],
    "forbidden": []
  },
  {
    "id": "hubspot-crawler",
    "category": "MONITORING",
    "name": "HubSpotBot",
    "patterns": [
      "HubSpot"
    ],
    "forbidden": []
  },
  {
    "id": "hydrozen-monitor",
    "category": "MONITORING",
    "name": "hydrozen-monitor",
    "patterns": [
      "Hydrozen\\.io\\/"
    ],
    "forbidden": []
  },
  {
    "id": "kuma-monitor",
    "category": "MONITORING",
    "name": "kuma-monitor",
    "patterns": [
      "Uptime-Kuma"
    ],
    "forbidden": []
  },
  {
    "id": "monitorbacklinks-crawler",
    "category": "MONITORING",
    "name": "monitorbacklinks-crawler",
    "patterns": [
      "MBCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "newrelic-monitor",
    "category": "MONITORING",
    "name": "newrelic-monitor",
    "patterns": [
      "NewRelicbot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "nixstats-crawler",
    "category": "MONITORING",
    "name": "nixstats-crawler",
    "patterns": [
      "NIXStatsbot"
    ],
    "forbidden": []
  },
  {
    "id": "outbrain-link-checker",
    "category": "MONITORING",
    "name": "outbrain-link-checker",
    "patterns": [
      "outbrain"
    ],
    "forbidden": []
  },
  {
    "id": "pingdom-crawler",
    "category": "MONITORING",
    "name": "Pingdom",
    "patterns": [
      "[pP]ingdom"
    ],
    "forbidden": []
  },
  {
    "id": "safedns-crawler",
    "category": "MONITORING",
    "name": "safedns-crawler",
    "patterns": [
      "SafeDNSBot"
    ],
    "forbidden": []
  },
  {
    "id": "sentry-crawler",
    "category": "MONITORING",
    "name": "sentry-crawler",
    "patterns": [
      "(^| )sentry\\/"
    ],
    "forbidden": []
  },
  {
    "id": "sentry-uptime-monitor",
    "category": "MONITORING",
    "name": "sentry-uptime-monitor",
    "patterns": [
      "SentryUptimeBot\\/1\\.0"
    ],
    "forbidden": []
  },
  {
    "id": "statuscake-monitor",
    "category": "MONITORING",
    "name": "statuscake-monitor",
    "patterns": [
      "StatusCake"
    ],
    "forbidden": []
  },
  {
    "id": "surly-crawler",
    "category": "MONITORING",
    "name": "surly-crawler",
    "patterns": [
      "SurdotlyBot"
    ],
    "forbidden": []
  },
  {
    "id": "testomato-crawler",
    "category": "MONITORING",
    "name": "testomato-crawler",
    "patterns": [
      "minicrawler"
    ],
    "forbidden": []
  },
  {
    "id": "uptime-monitor",
    "category": "MONITORING",
    "name": "uptime-monitor",
    "patterns": [
      "www\\.uptime\\.com"
    ],
    "forbidden": []
  },
  {
    "id": "uptimebot-monitor",
    "category": "MONITORING",
    "name": "uptimebot-monitor",
    "patterns": [
      "Uptimebot\\.org"
    ],
    "forbidden": []
  },
  {
    "id": "uptimerobot-monitor",
    "category": "MONITORING",
    "name": "UptimeRobot",
    "patterns": [
      "UptimeRobot"
    ],
    "forbidden": []
  },
  {
    "id": "w3c-validator-css",
    "category": "MONITORING",
    "name": "w3c-validator-css",
    "patterns": [
      "W3C_CSS_Validator"
    ],
    "forbidden": []
  },
  {
    "id": "w3c-validator-feed",
    "category": "MONITORING",
    "name": "w3c-validator-feed",
    "patterns": [
      "FeedValidator"
    ],
    "forbidden": []
  },
  {
    "id": "w3c-validator-html",
    "category": "MONITORING",
    "name": "w3c-validator-html",
    "patterns": [
      "W3C_Validator"
    ],
    "forbidden": []
  },
  {
    "id": "w3c-validator-html-nu",
    "category": "MONITORING",
    "name": "w3c-validator-html-nu",
    "patterns": [
      "Validator\\.nu"
    ],
    "forbidden": []
  },
  {
    "id": "w3c-validator-i18n",
    "category": "MONITORING",
    "name": "w3c-validator-i18n",
    "patterns": [
      "W3C_I18n-Checker"
    ],
    "forbidden": []
  },
  {
    "id": "w3c-validator-links",
    "category": "MONITORING",
    "name": "w3c-validator-links",
    "patterns": [
      "W3C-checklink"
    ],
    "forbidden": []
  },
  {
    "id": "w3c-validator-mobile",
    "category": "MONITORING",
    "name": "w3c-validator-mobile",
    "patterns": [
      "W3C-mobileOK"
    ],
    "forbidden": []
  },
  {
    "id": "w3c-validator-unified",
    "category": "MONITORING",
    "name": "w3c-validator-unified",
    "patterns": [
      "W3C_Unicorn"
    ],
    "forbidden": []
  },
  {
    "id": "webpagetest-crawler",
    "category": "MONITORING",
    "name": "webpagetest-crawler",
    "patterns": [
      "(^| )PTST\\/"
    ],
    "forbidden": []
  },
  {
    "id": "xenu-crawler",
    "category": "MONITORING",
    "name": "xenu-crawler",
    "patterns": [
      "Xenu Link Sleuth"
    ],
    "forbidden": []
  },
  {
    "id": "zabbix-monitor",
    "category": "MONITORING",
    "name": "zabbix-monitor",
    "patterns": [
      "Zabbix"
    ],
    "forbidden": []
  },
  {
    "id": "academicbot-rtu",
    "category": "SCRAPER",
    "name": "academicbot-rtu",
    "patterns": [
      "AcademicBotRTU"
    ],
    "forbidden": []
  },
  {
    "id": "adagio-crawler",
    "category": "SCRAPER",
    "name": "adagio-crawler",
    "patterns": [
      "Adagiobot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "ahrefs-site-audit",
    "category": "SCRAPER",
    "name": "ahrefs-site-audit",
    "patterns": [
      "AhrefsSiteAudit\\/"
    ],
    "forbidden": []
  },
  {
    "id": "blackboard-crawler",
    "category": "SCRAPER",
    "name": "blackboard-crawler",
    "patterns": [
      "Blackboard"
    ],
    "forbidden": []
  },
  {
    "id": "cispa-crawler",
    "category": "SCRAPER",
    "name": "cispa-crawler",
    "patterns": [
      "CISPA Webcrawler"
    ],
    "forbidden": []
  },
  {
    "id": "cloudflare-prefetch",
    "category": "SCRAPER",
    "name": "cloudflare-prefetch",
    "patterns": [
      "CloudFlare-Prefetch"
    ],
    "forbidden": []
  },
  {
    "id": "coda-server-fetcher",
    "category": "SCRAPER",
    "name": "coda-server-fetcher",
    "patterns": [
      "Coda-Server-Fetcher"
    ],
    "forbidden": []
  },
  {
    "id": "conductor-crawler",
    "category": "SCRAPER",
    "name": "conductor-crawler",
    "patterns": [
      "Caliperbot"
    ],
    "forbidden": []
  },
  {
    "id": "cookiehub-scan",
    "category": "SCRAPER",
    "name": "cookiehub-scan",
    "patterns": [
      "CookieHubScan"
    ],
    "forbidden": []
  },
  {
    "id": "curl",
    "category": "SCRAPER",
    "name": "curl",
    "patterns": [
      "^curl"
    ],
    "forbidden": []
  },
  {
    "id": "dareboost-crawler",
    "category": "SCRAPER",
    "name": "dareboost-crawler",
    "patterns": [
      "DareBoost"
    ],
    "forbidden": []
  },
  {
    "id": "dcrawl",
    "category": "SCRAPER",
    "name": "dcrawl",
    "patterns": [
      "dcrawl"
    ],
    "forbidden": []
  },
  {
    "id": "domainsproject-crawler",
    "category": "SCRAPER",
    "name": "domainsproject-crawler",
    "patterns": [
      "Domains Project\\/"
    ],
    "forbidden": []
  },
  {
    "id": "epfl-crawler",
    "category": "SCRAPER",
    "name": "epfl-crawler",
    "patterns": [
      "A Patent Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "gigablast-crawler-oss",
    "category": "SCRAPER",
    "name": "gigablast-crawler-oss",
    "patterns": [
      "Gigablast"
    ],
    "forbidden": []
  },
  {
    "id": "go-http",
    "category": "SCRAPER",
    "name": "Go-http-client",
    "patterns": [
      "Go-http-client"
    ],
    "forbidden": []
  },
  {
    "id": "got",
    "category": "SCRAPER",
    "name": "got",
    "patterns": [
      "sindresorhus\\/got"
    ],
    "forbidden": []
  },
  {
    "id": "gowiki-crawler",
    "category": "SCRAPER",
    "name": "gowiki-crawler",
    "patterns": [
      "Gowikibot"
    ],
    "forbidden": []
  },
  {
    "id": "http-get",
    "category": "SCRAPER",
    "name": "http-get",
    "patterns": [
      "http_get"
    ],
    "forbidden": []
  },
  {
    "id": "httpie",
    "category": "SCRAPER",
    "name": "HTTPie",
    "patterns": [
      "^HTTPie\\/"
    ],
    "forbidden": []
  },
  {
    "id": "img2dataset",
    "category": "SCRAPER",
    "name": "img2dataset",
    "patterns": [
      "img2dataset"
    ],
    "forbidden": []
  },
  {
    "id": "insomnia",
    "category": "SCRAPER",
    "name": "Insomnia",
    "patterns": [
      "^[iI]nsomnia"
    ],
    "forbidden": []
  },
  {
    "id": "ipip-crawler",
    "category": "SCRAPER",
    "name": "ipip-crawler",
    "patterns": [
      "HTTP Banner Detection"
    ],
    "forbidden": []
  },
  {
    "id": "java-apache-httpclient",
    "category": "SCRAPER",
    "name": "Apache HttpClient",
    "patterns": [
      "^Apache-HttpClient"
    ],
    "forbidden": []
  },
  {
    "id": "java-asynchttpclient",
    "category": "SCRAPER",
    "name": "java-asynchttpclient",
    "patterns": [
      "AHC\\/"
    ],
    "forbidden": []
  },
  {
    "id": "java-crawler4j",
    "category": "SCRAPER",
    "name": "java-crawler4j",
    "patterns": [
      "crawler4j"
    ],
    "forbidden": []
  },
  {
    "id": "java-httpunit",
    "category": "SCRAPER",
    "name": "java-httpunit",
    "patterns": [
      "httpunit"
    ],
    "forbidden": []
  },
  {
    "id": "java-jersey",
    "category": "SCRAPER",
    "name": "java-jersey",
    "patterns": [
      "HttpUrlConnection"
    ],
    "forbidden": []
  },
  {
    "id": "java-jetty",
    "category": "SCRAPER",
    "name": "java-jetty",
    "patterns": [
      "Jetty"
    ],
    "forbidden": []
  },
  {
    "id": "java-okhttp",
    "category": "SCRAPER",
    "name": "OkHttp",
    "patterns": [
      "okhttp"
    ],
    "forbidden": []
  },
  {
    "id": "java-snacktory",
    "category": "SCRAPER",
    "name": "java-snacktory",
    "patterns": [
      "Snacktory"
    ],
    "forbidden": []
  },
  {
    "id": "java-stdlib",
    "category": "SCRAPER",
    "name": "Java HttpClient",
    "patterns": [
      "^Java\\/"
    ],
    "forbidden": []
  },
  {
    "id": "javascript-axios",
    "category": "SCRAPER",
    "name": "axios",
    "patterns": [
      "axios"
    ],
    "forbidden": []
  },
  {
    "id": "javascript-node-fetch",
    "category": "SCRAPER",
    "name": "node-fetch",
    "patterns": [
      "node-fetch"
    ],
    "forbidden": []
  },
  {
    "id": "l9explore",
    "category": "SCRAPER",
    "name": "l9explore",
    "patterns": [
      "l9explore"
    ],
    "forbidden": []
  },
  {
    "id": "law-unimi-crawler",
    "category": "SCRAPER",
    "name": "law-unimi-crawler",
    "patterns": [
      "BUbiNG"
    ],
    "forbidden": []
  },
  {
    "id": "leipzig-findlinks",
    "category": "SCRAPER",
    "name": "leipzig-findlinks",
    "patterns": [
      "findlink"
    ],
    "forbidden": []
  },
  {
    "id": "leipzig-lcc",
    "category": "SCRAPER",
    "name": "leipzig-lcc",
    "patterns": [
      "^LCC "
    ],
    "forbidden": []
  },
  {
    "id": "macocu-crawler",
    "category": "SCRAPER",
    "name": "macocu-crawler",
    "patterns": [
      "MaCoCu"
    ],
    "forbidden": []
  },
  {
    "id": "moat-crawler",
    "category": "SCRAPER",
    "name": "moat-crawler",
    "patterns": [
      "moatbot"
    ],
    "forbidden": []
  },
  {
    "id": "monsido-crawler",
    "category": "SCRAPER",
    "name": "monsido-crawler",
    "patterns": [
      "Monsidobot"
    ],
    "forbidden": []
  },
  {
    "id": "moz-site-audit",
    "category": "SCRAPER",
    "name": "RogerBot",
    "patterns": [
      "rogerbot"
    ],
    "forbidden": []
  },
  {
    "id": "nagios-check-http",
    "category": "SCRAPER",
    "name": "nagios-check-http",
    "patterns": [
      "check_http"
    ],
    "forbidden": []
  },
  {
    "id": "nict-crawler",
    "category": "SCRAPER",
    "name": "nict-crawler",
    "patterns": [
      "ICC-Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "nmap",
    "category": "SECURITY_SCANNER",
    "name": "nmap",
    "patterns": [
      "Nmap Scripting Engine"
    ],
    "forbidden": []
  },
  {
    "id": "nutch",
    "category": "SCRAPER",
    "name": "nutch",
    "patterns": [
      "Nutch"
    ],
    "forbidden": []
  },
  {
    "id": "oncrawl",
    "category": "SCRAPER",
    "name": "oncrawl",
    "patterns": [
      "OnCrawl\\/"
    ],
    "forbidden": []
  },
  {
    "id": "perl-libwww",
    "category": "SCRAPER",
    "name": "libwww-perl",
    "patterns": [
      "libwww-perl"
    ],
    "forbidden": []
  },
  {
    "id": "perl-pcore",
    "category": "SCRAPER",
    "name": "perl-pcore",
    "patterns": [
      "Pcore-HTTP"
    ],
    "forbidden": []
  },
  {
    "id": "php-curlclass",
    "category": "SCRAPER",
    "name": "php-curlclass",
    "patterns": [
      "^PHP-Curl-Class"
    ],
    "forbidden": []
  },
  {
    "id": "php-phpcrawl",
    "category": "SCRAPER",
    "name": "php-phpcrawl",
    "patterns": [
      "phpcrawl"
    ],
    "forbidden": []
  },
  {
    "id": "php-simple-scraper",
    "category": "SCRAPER",
    "name": "php-simple-scraper",
    "patterns": [
      "SimpleScraper"
    ],
    "forbidden": []
  },
  {
    "id": "php-simplepie",
    "category": "SCRAPER",
    "name": "php-simplepie",
    "patterns": [
      "SimplePie"
    ],
    "forbidden": []
  },
  {
    "id": "php-ua",
    "category": "SCRAPER",
    "name": "PHP",
    "patterns": [
      "^PHP\\/"
    ],
    "forbidden": []
  },
  {
    "id": "postman",
    "category": "SCRAPER",
    "name": "Postman",
    "patterns": [
      "PostmanRuntime\\/"
    ],
    "forbidden": []
  },
  {
    "id": "postman-loose",
    "category": "SCRAPER",
    "name": "Postman",
    "patterns": [
      "^Postman[ /]"
    ],
    "forbidden": []
  },
  {
    "id": "python-aiohttp",
    "category": "SCRAPER",
    "name": "python-aiohttp",
    "patterns": [
      "aiohttp"
    ],
    "forbidden": []
  },
  {
    "id": "python-bitbot",
    "category": "SCRAPER",
    "name": "python-bitbot",
    "patterns": [
      "BitBot"
    ],
    "forbidden": []
  },
  {
    "id": "python-httpx",
    "category": "SCRAPER",
    "name": "python-httpx",
    "patterns": [
      "httpx"
    ],
    "forbidden": []
  },
  {
    "id": "python-opengraph",
    "category": "SCRAPER",
    "name": "python-opengraph",
    "patterns": [
      "python-opengraph"
    ],
    "forbidden": []
  },
  {
    "id": "python-requests",
    "category": "SCRAPER",
    "name": "python-requests",
    "patterns": [
      "python-requests"
    ],
    "forbidden": []
  },
  {
    "id": "python-scrapy",
    "category": "SCRAPER",
    "name": "Scrapy",
    "patterns": [
      "Scrapy"
    ],
    "forbidden": []
  },
  {
    "id": "python-urllib",
    "category": "SCRAPER",
    "name": "python-urllib",
    "patterns": [
      "Python-urllib"
    ],
    "forbidden": []
  },
  {
    "id": "quantcast-crawler",
    "category": "SCRAPER",
    "name": "quantcast-crawler",
    "patterns": [
      "Quantcastbot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "ruby",
    "category": "SCRAPER",
    "name": "Ruby",
    "patterns": [
      "^Ruby"
    ],
    "forbidden": []
  },
  {
    "id": "ruby-metainspector",
    "category": "SCRAPER",
    "name": "ruby-metainspector",
    "patterns": [
      "MetaInspector"
    ],
    "forbidden": []
  },
  {
    "id": "screamingfrog-crawler",
    "category": "SCRAPER",
    "name": "screamingfrog-crawler",
    "patterns": [
      "Screaming Frog SEO Spider"
    ],
    "forbidden": []
  },
  {
    "id": "semanticscholar-crawler",
    "category": "SCRAPER",
    "name": "SemanticScholarBot",
    "patterns": [
      "SemanticScholarBot"
    ],
    "forbidden": []
  },
  {
    "id": "sistrix-crawler",
    "category": "SCRAPER",
    "name": "sistrix-crawler",
    "patterns": [
      "(sistrix|SISTRIX) [cC]rawler"
    ],
    "forbidden": []
  },
  {
    "id": "sitebulb",
    "category": "SCRAPER",
    "name": "sitebulb",
    "patterns": [
      "sitebulb"
    ],
    "forbidden": []
  },
  {
    "id": "stripe-crawler",
    "category": "SCRAPER",
    "name": "stripe-crawler",
    "patterns": [
      "Stripebot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "summaly-crawler",
    "category": "SCRAPER",
    "name": "summaly-crawler",
    "patterns": [
      "SummalyBot"
    ],
    "forbidden": []
  },
  {
    "id": "turnitin-crawler",
    "category": "SCRAPER",
    "name": "turnitin-crawler",
    "patterns": [
      "Turnitin"
    ],
    "forbidden": []
  },
  {
    "id": "utexas-crawler",
    "category": "SCRAPER",
    "name": "utexas-crawler",
    "patterns": [
      "UT-Dorkbot"
    ],
    "forbidden": []
  },
  {
    "id": "wget",
    "category": "SCRAPER",
    "name": "wget",
    "patterns": [
      "[wW]get"
    ],
    "forbidden": []
  },
  {
    "id": "yamanalab-crawler",
    "category": "SCRAPER",
    "name": "yamanalab-crawler",
    "patterns": [
      "Sonic"
    ],
    "forbidden": []
  },
  {
    "id": "yext-bot",
    "category": "SCRAPER",
    "name": "yext-bot",
    "patterns": [
      "YextBot"
    ],
    "forbidden": []
  },
  {
    "id": "zgrab",
    "category": "SECURITY_SCANNER",
    "name": "zgrab",
    "patterns": [
      "zgrab"
    ],
    "forbidden": []
  },
  {
    "id": "addsearch-crawler",
    "category": "SEARCH_ENGINE",
    "name": "addsearch-crawler",
    "patterns": [
      "AddSearchBot"
    ],
    "forbidden": []
  },
  {
    "id": "ahrefs-crawler",
    "category": "SEARCH_ENGINE",
    "name": "AhrefsBot",
    "patterns": [
      "AhrefsBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "alexandria-crawler",
    "category": "SEARCH_ENGINE",
    "name": "alexandria-crawler",
    "patterns": [
      "AlexandriaOrgBot"
    ],
    "forbidden": []
  },
  {
    "id": "algolia-crawler",
    "category": "SEARCH_ENGINE",
    "name": "algolia-crawler",
    "patterns": [
      "Algolia Crawler\\/"
    ],
    "forbidden": []
  },
  {
    "id": "amazon-adbot",
    "category": "SEARCH_ENGINE",
    "name": "amazon-adbot",
    "patterns": [
      "AmazonAdBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "amazon-alexa-crawler",
    "category": "SEARCH_ENGINE",
    "name": "amazon-alexa-crawler",
    "patterns": [
      "exabot"
    ],
    "forbidden": []
  },
  {
    "id": "amazon-cloudfront",
    "category": "SEARCH_ENGINE",
    "name": "amazon-cloudfront",
    "patterns": [
      "Amazon CloudFront"
    ],
    "forbidden": []
  },
  {
    "id": "amazon-crawler",
    "category": "SEARCH_ENGINE",
    "name": "AmazonBot",
    "patterns": [
      "Amazonbot"
    ],
    "forbidden": []
  },
  {
    "id": "apple-crawler",
    "category": "SEARCH_ENGINE",
    "name": "Applebot",
    "patterns": [
      "Applebot"
    ],
    "forbidden": []
  },
  {
    "id": "apple-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "apple-feedfetcher",
    "patterns": [
      "i[Tt][Mm][Ss]"
    ],
    "forbidden": []
  },
  {
    "id": "archiveorg-archiver",
    "category": "SEARCH_ENGINE",
    "name": "ArchiveOrgBot",
    "patterns": [
      "archive\\.org_bot"
    ],
    "forbidden": []
  },
  {
    "id": "ask-crawler",
    "category": "SEARCH_ENGINE",
    "name": "ask-crawler",
    "patterns": [
      "Teoma"
    ],
    "forbidden": []
  },
  {
    "id": "avira-crawler",
    "category": "SEARCH_ENGINE",
    "name": "avira-crawler",
    "patterns": [
      "SafeSearch microdata crawler"
    ],
    "forbidden": []
  },
  {
    "id": "awario-crawler-rss",
    "category": "SEARCH_ENGINE",
    "name": "awario-crawler-rss",
    "patterns": [
      "AwarioRssBot"
    ],
    "forbidden": []
  },
  {
    "id": "baidu-crawler",
    "category": "SEARCH_ENGINE",
    "name": "Baiduspider",
    "patterns": [
      "Baiduspider"
    ],
    "forbidden": []
  },
  {
    "id": "bazqux-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "bazqux-feedfetcher",
    "patterns": [
      "BazQux"
    ],
    "forbidden": []
  },
  {
    "id": "bing-ads",
    "category": "SEARCH_ENGINE",
    "name": "bing-ads",
    "patterns": [
      "Adidxbot"
    ],
    "forbidden": []
  },
  {
    "id": "bing-crawler",
    "category": "SEARCH_ENGINE",
    "name": "Bingbot",
    "patterns": [
      "bingbot"
    ],
    "forbidden": []
  },
  {
    "id": "bing-office-store",
    "category": "SEARCH_ENGINE",
    "name": "bing-office-store",
    "patterns": [
      "officestorebot"
    ],
    "forbidden": []
  },
  {
    "id": "blogtraffic-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "blogtraffic-feedfetcher",
    "patterns": [
      "BlogTraffic\\/\\d\\.\\d+ Feed-Fetcher"
    ],
    "forbidden": []
  },
  {
    "id": "cloudflare-archiver",
    "category": "SEARCH_ENGINE",
    "name": "cloudflare-archiver",
    "patterns": [
      "CloudFlare-AlwaysOnline"
    ],
    "forbidden": []
  },
  {
    "id": "commoncrawl-crawler",
    "category": "SEARCH_ENGINE",
    "name": "CommonCrawlBot",
    "patterns": [
      "CCBot"
    ],
    "forbidden": []
  },
  {
    "id": "duckduckgo-crawler",
    "category": "SEARCH_ENGINE",
    "name": "DuckDuckBot",
    "patterns": [
      "DuckDuckBot"
    ],
    "forbidden": []
  },
  {
    "id": "entireweb-crawler",
    "category": "SEARCH_ENGINE",
    "name": "entireweb-crawler",
    "patterns": [
      "speedy"
    ],
    "forbidden": []
  },
  {
    "id": "ezid-crawler",
    "category": "SEARCH_ENGINE",
    "name": "ezid-crawler",
    "patterns": [
      "EZID"
    ],
    "forbidden": []
  },
  {
    "id": "feedbin-crawler",
    "category": "SEARCH_ENGINE",
    "name": "feedbin-crawler",
    "patterns": [
      "Feedbin"
    ],
    "forbidden": []
  },
  {
    "id": "feedly-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "feedly-feedfetcher",
    "patterns": [
      "Feedly"
    ],
    "forbidden": []
  },
  {
    "id": "feedspot-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "feedspot-feedfetcher",
    "patterns": [
      "Feedspot"
    ],
    "forbidden": []
  },
  {
    "id": "freshrss-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "freshrss-feedfetcher",
    "patterns": [
      "FreshRSS"
    ],
    "forbidden": []
  },
  {
    "id": "g2reader-crawler",
    "category": "SEARCH_ENGINE",
    "name": "g2reader-crawler",
    "patterns": [
      "g2reader-bot"
    ],
    "forbidden": []
  },
  {
    "id": "geedo-crawler",
    "category": "SEARCH_ENGINE",
    "name": "geedo-crawler",
    "patterns": [
      "GeedoBot"
    ],
    "forbidden": []
  },
  {
    "id": "geedo-crawler-products",
    "category": "SEARCH_ENGINE",
    "name": "geedo-crawler-products",
    "patterns": [
      "GeedoProductSearch"
    ],
    "forbidden": []
  },
  {
    "id": "google-ads-conversions",
    "category": "SEARCH_ENGINE",
    "name": "google-ads-conversions",
    "patterns": [
      "Google-Ads-Conversions"
    ],
    "forbidden": []
  },
  {
    "id": "google-adsbot",
    "category": "SEARCH_ENGINE",
    "name": "AdsBotGoogle",
    "patterns": [
      "AdsBot-Google([^-]|$)"
    ],
    "forbidden": []
  },
  {
    "id": "google-adsbot-mobile",
    "category": "SEARCH_ENGINE",
    "name": "GoogleAdsBot",
    "patterns": [
      "AdsBot-Google-Mobile"
    ],
    "forbidden": []
  },
  {
    "id": "google-adsense",
    "category": "SEARCH_ENGINE",
    "name": "MediapartnersGoogle",
    "patterns": [
      "Mediapartners-Google"
    ],
    "forbidden": []
  },
  {
    "id": "google-adsense-googlebot",
    "category": "SEARCH_ENGINE",
    "name": "google-adsense-googlebot",
    "patterns": [
      "Mediapartners \\(Googlebot\\)"
    ],
    "forbidden": []
  },
  {
    "id": "google-adwords",
    "category": "SEARCH_ENGINE",
    "name": "google-adwords",
    "patterns": [
      "Google-Adwords-Instant"
    ],
    "forbidden": []
  },
  {
    "id": "google-appengine",
    "category": "SEARCH_ENGINE",
    "name": "google-appengine",
    "patterns": [
      "AppEngine-Google"
    ],
    "forbidden": []
  },
  {
    "id": "google-crawler",
    "category": "SEARCH_ENGINE",
    "name": "Googlebot",
    "patterns": [
      "Googlebot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "google-crawler-cloudvertex",
    "category": "SEARCH_ENGINE",
    "name": "google-crawler-cloudvertex",
    "patterns": [
      "Google-CloudVertexBot"
    ],
    "forbidden": []
  },
  {
    "id": "google-crawler-image",
    "category": "SEARCH_ENGINE",
    "name": "Googlebot-Image",
    "patterns": [
      "Googlebot-Image"
    ],
    "forbidden": []
  },
  {
    "id": "google-crawler-mobile",
    "category": "SEARCH_ENGINE",
    "name": "google-crawler-mobile",
    "patterns": [
      "Googlebot-Mobile"
    ],
    "forbidden": []
  },
  {
    "id": "google-crawler-news",
    "category": "SEARCH_ENGINE",
    "name": "Googlebot-News",
    "patterns": [
      "Googlebot-News"
    ],
    "forbidden": []
  },
  {
    "id": "google-crawler-other",
    "category": "SEARCH_ENGINE",
    "name": "google-crawler-other",
    "patterns": [
      "GoogleOther"
    ],
    "forbidden": []
  },
  {
    "id": "google-crawler-safety",
    "category": "SEARCH_ENGINE",
    "name": "google-crawler-safety",
    "patterns": [
      "Google-Safety"
    ],
    "forbidden": []
  },
  {
    "id": "google-crawler-store",
    "category": "SEARCH_ENGINE",
    "name": "StorebotGoogle",
    "patterns": [
      "Storebot-Google"
    ],
    "forbidden": []
  },
  {
    "id": "google-crawler-video",
    "category": "SEARCH_ENGINE",
    "name": "Googlebot-Video",
    "patterns": [
      "Googlebot-Video"
    ],
    "forbidden": []
  },
  {
    "id": "google-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "google-feedfetcher",
    "patterns": [
      "Feedfetcher-Google"
    ],
    "forbidden": []
  },
  {
    "id": "google-inspection-tool",
    "category": "SEARCH_ENGINE",
    "name": "google-inspection-tool",
    "patterns": [
      "Google-InspectionTool"
    ],
    "forbidden": []
  },
  {
    "id": "google-lighthouse",
    "category": "SEARCH_ENGINE",
    "name": "google-lighthouse",
    "patterns": [
      "Chrome-Lighthouse"
    ],
    "forbidden": []
  },
  {
    "id": "google-physical-web",
    "category": "SEARCH_ENGINE",
    "name": "google-physical-web",
    "patterns": [
      "Google-PhysicalWeb"
    ],
    "forbidden": []
  },
  {
    "id": "google-push-notifications",
    "category": "SEARCH_ENGINE",
    "name": "APIsGoogle",
    "patterns": [
      "APIs-Google"
    ],
    "forbidden": []
  },
  {
    "id": "google-read-aloud",
    "category": "SEARCH_ENGINE",
    "name": "google-read-aloud",
    "patterns": [
      "Google-Read-Aloud"
    ],
    "forbidden": []
  },
  {
    "id": "google-xrawler",
    "category": "SEARCH_ENGINE",
    "name": "google-xrawler",
    "patterns": [
      "google-xrawler"
    ],
    "forbidden": []
  },
  {
    "id": "iask-crawler",
    "category": "SEARCH_ENGINE",
    "name": "iask-crawler",
    "patterns": [
      "iaskspider"
    ],
    "forbidden": []
  },
  {
    "id": "inoreader-aggregator",
    "category": "SEARCH_ENGINE",
    "name": "inoreader-aggregator",
    "patterns": [
      "inoreader"
    ],
    "forbidden": []
  },
  {
    "id": "internetarchive-crawler-oss",
    "category": "SEARCH_ENGINE",
    "name": "internetarchive-crawler-oss",
    "patterns": [
      "heritrix"
    ],
    "forbidden": []
  },
  {
    "id": "linguee-crawler",
    "category": "SEARCH_ENGINE",
    "name": "linguee-crawler",
    "patterns": [
      "Linguee Bot"
    ],
    "forbidden": []
  },
  {
    "id": "majestic-crawler",
    "category": "SEARCH_ENGINE",
    "name": "majestic-crawler",
    "patterns": [
      "MJ12bot"
    ],
    "forbidden": []
  },
  {
    "id": "marginalia-crawler",
    "category": "SEARCH_ENGINE",
    "name": "marginalia-crawler",
    "patterns": [
      "search\\.marginalia\\.nu"
    ],
    "forbidden": []
  },
  {
    "id": "meta-crawler",
    "category": "SEARCH_ENGINE",
    "name": "meta-crawler",
    "patterns": [
      "[Mm]eta-[Ee]xternal[Aa]gent"
    ],
    "forbidden": []
  },
  {
    "id": "meta-externalads",
    "category": "SEARCH_ENGINE",
    "name": "meta-externalads",
    "patterns": [
      "meta-externalads\\/"
    ],
    "forbidden": []
  },
  {
    "id": "microsoft-research-crawler",
    "category": "SEARCH_ENGINE",
    "name": "microsoft-research-crawler",
    "patterns": [
      "msrbot"
    ],
    "forbidden": []
  },
  {
    "id": "miniflux-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "miniflux-feedfetcher",
    "patterns": [
      "Miniflux\\/"
    ],
    "forbidden": []
  },
  {
    "id": "mojeek-crawler",
    "category": "SEARCH_ENGINE",
    "name": "mojeek-crawler",
    "patterns": [
      "MojeekBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "msn-crawler",
    "category": "SEARCH_ENGINE",
    "name": "MsnBot",
    "patterns": [
      "msnbot"
    ],
    "forbidden": []
  },
  {
    "id": "naver-crawler-rss",
    "category": "SEARCH_ENGINE",
    "name": "naver-crawler-rss",
    "patterns": [
      "NAVER Blog Rssbot"
    ],
    "forbidden": []
  },
  {
    "id": "netestate-crawler",
    "category": "SEARCH_ENGINE",
    "name": "netestate-crawler",
    "patterns": [
      "netEstate NE Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "newsblur-aggregator",
    "category": "SEARCH_ENGINE",
    "name": "newsblur-aggregator",
    "patterns": [
      "NewsBlur"
    ],
    "forbidden": []
  },
  {
    "id": "nicecrawler-archive",
    "category": "SEARCH_ENGINE",
    "name": "nicecrawler-archive",
    "patterns": [
      "Nicecrawler"
    ],
    "forbidden": []
  },
  {
    "id": "openai-crawler-search",
    "category": "SEARCH_ENGINE",
    "name": "OAISearchBot",
    "patterns": [
      "OAI-SearchBot"
    ],
    "forbidden": []
  },
  {
    "id": "petalsearch-crawler",
    "category": "SEARCH_ENGINE",
    "name": "petalsearch-crawler",
    "patterns": [
      "PetalBot"
    ],
    "forbidden": []
  },
  {
    "id": "pipl-crawler",
    "category": "SEARCH_ENGINE",
    "name": "pipl-crawler",
    "patterns": [
      "PiplBot"
    ],
    "forbidden": []
  },
  {
    "id": "pocket-crawler",
    "category": "SEARCH_ENGINE",
    "name": "pocket-crawler",
    "patterns": [
      "PocketParser"
    ],
    "forbidden": []
  },
  {
    "id": "qwant-crawler",
    "category": "SEARCH_ENGINE",
    "name": "qwant-crawler",
    "patterns": [
      "Qwantify"
    ],
    "forbidden": []
  },
  {
    "id": "refind-crawler",
    "category": "SEARCH_ENGINE",
    "name": "refind-crawler",
    "patterns": [
      "Refindbot"
    ],
    "forbidden": []
  },
  {
    "id": "rssbot-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "rssbot-feedfetcher",
    "patterns": [
      "rssbot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "rssing-crawler",
    "category": "SEARCH_ENGINE",
    "name": "rssing-crawler",
    "patterns": [
      "RSSingBot"
    ],
    "forbidden": []
  },
  {
    "id": "rssmicro-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "rssmicro-feedfetcher",
    "patterns": [
      "Atom Feed Robot"
    ],
    "forbidden": []
  },
  {
    "id": "seekport-crawler",
    "category": "SEARCH_ENGINE",
    "name": "seekport-crawler",
    "patterns": [
      "Seekport"
    ],
    "forbidden": []
  },
  {
    "id": "serendeputy-crawler",
    "category": "SEARCH_ENGINE",
    "name": "serendeputy-crawler",
    "patterns": [
      "SerendeputyBot"
    ],
    "forbidden": []
  },
  {
    "id": "startme-crawler",
    "category": "SEARCH_ENGINE",
    "name": "startme-crawler",
    "patterns": [
      "startmebot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "stract-crawler",
    "category": "SEARCH_ENGINE",
    "name": "stract-crawler",
    "patterns": [
      "StractBot"
    ],
    "forbidden": []
  },
  {
    "id": "superfeedr-crawler",
    "category": "SEARCH_ENGINE",
    "name": "superfeedr-crawler",
    "patterns": [
      "Superfeedr"
    ],
    "forbidden": []
  },
  {
    "id": "theoldreader-crawler",
    "category": "SEARCH_ENGINE",
    "name": "theoldreader-crawler",
    "patterns": [
      "theoldreader\\.com"
    ],
    "forbidden": []
  },
  {
    "id": "ttrss-feedfetcher",
    "category": "SEARCH_ENGINE",
    "name": "ttrss-feedfetcher",
    "patterns": [
      "Tiny Tiny RSS"
    ],
    "forbidden": []
  },
  {
    "id": "webarchive-crawler",
    "category": "SEARCH_ENGINE",
    "name": "webarchive-crawler",
    "patterns": [
      "web-archive-net\\.com\\.bot"
    ],
    "forbidden": []
  },
  {
    "id": "webzio-crawler",
    "category": "SEARCH_ENGINE",
    "name": "webzio-crawler",
    "patterns": [
      "webzio\\s"
    ],
    "forbidden": []
  },
  {
    "id": "wellknown-crawler",
    "category": "SEARCH_ENGINE",
    "name": "wellknown-crawler",
    "patterns": [
      "WellKnownBot"
    ],
    "forbidden": []
  },
  {
    "id": "wordpress-crawler-rss",
    "category": "SEARCH_ENGINE",
    "name": "wordpress-crawler-rss",
    "patterns": [
      "feedbot"
    ],
    "forbidden": []
  },
  {
    "id": "yacy-crawler",
    "category": "SEARCH_ENGINE",
    "name": "yacy-crawler",
    "patterns": [
      "yacybot"
    ],
    "forbidden": []
  },
  {
    "id": "yahoo-crawler",
    "category": "SEARCH_ENGINE",
    "name": "SlurpBot",
    "patterns": [
      "Slurp"
    ],
    "forbidden": []
  },
  {
    "id": "yahoo-crawler-japan",
    "category": "SEARCH_ENGINE",
    "name": "yahoo-crawler-japan",
    "patterns": [
      "Y!J"
    ],
    "forbidden": []
  },
  {
    "id": "yandex-crawler",
    "category": "SEARCH_ENGINE",
    "name": "YandexBot",
    "patterns": [
      "yandex\\.com\\/bots"
    ],
    "forbidden": []
  },
  {
    "id": "yandex-crawler-javascript",
    "category": "SEARCH_ENGINE",
    "name": "yandex-crawler-javascript",
    "patterns": [
      "YandexRenderResourcesBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "yandex-loose",
    "category": "SEARCH_ENGINE",
    "name": "YandexBot",
    "patterns": [
      "YandexBot"
    ],
    "forbidden": []
  },
  {
    "id": "adyen-webhook",
    "category": "SOCIAL",
    "name": "adyen-webhook",
    "patterns": [
      "Adyen HttpClient"
    ],
    "forbidden": []
  },
  {
    "id": "bing-preview",
    "category": "SOCIAL",
    "name": "BingPreviewBot",
    "patterns": [
      "BingPreview\\/"
    ],
    "forbidden": []
  },
  {
    "id": "bitly-crawler",
    "category": "SOCIAL",
    "name": "bitly-crawler",
    "patterns": [
      "bitlybot"
    ],
    "forbidden": []
  },
  {
    "id": "digg-crawler",
    "category": "SOCIAL",
    "name": "digg-crawler",
    "patterns": [
      "Digg Deeper"
    ],
    "forbidden": []
  },
  {
    "id": "discord-crawler",
    "category": "SOCIAL",
    "name": "Discordbot",
    "patterns": [
      "Discordbot"
    ],
    "forbidden": []
  },
  {
    "id": "duckduckgo-crawler-favicons",
    "category": "SOCIAL",
    "name": "duckduckgo-crawler-favicons",
    "patterns": [
      "DuckDuckGo-Favicons-Bot"
    ],
    "forbidden": []
  },
  {
    "id": "embedly-crawler",
    "category": "SOCIAL",
    "name": "EmbedlyBot",
    "patterns": [
      "Embedly"
    ],
    "forbidden": []
  },
  {
    "id": "everyonesocial-crawler",
    "category": "SOCIAL",
    "name": "everyonesocial-crawler",
    "patterns": [
      "EveryoneSocialBot"
    ],
    "forbidden": []
  },
  {
    "id": "facebook-catalog",
    "category": "SOCIAL",
    "name": "facebook-catalog",
    "patterns": [
      "facebookcatalog\\/"
    ],
    "forbidden": []
  },
  {
    "id": "facebook-crawler",
    "category": "SOCIAL",
    "name": "FacebookBot",
    "patterns": [
      "Face(book){0,1}[Bb]ot"
    ],
    "forbidden": [
      "facebookexternalhit",
      "Twitterbot"
    ]
  },
  {
    "id": "facebook-share-crawler",
    "category": "SOCIAL",
    "name": "Facebook",
    "patterns": [
      "facebookexternalhit"
    ],
    "forbidden": [
      "Twitterbot",
      "Facebot"
    ]
  },
  {
    "id": "flipboard-proxy",
    "category": "SOCIAL",
    "name": "flipboard-proxy",
    "patterns": [
      "FlipboardProxy"
    ],
    "forbidden": []
  },
  {
    "id": "google-favicon",
    "category": "SOCIAL",
    "name": "google-favicon",
    "patterns": [
      "Google Favicon"
    ],
    "forbidden": []
  },
  {
    "id": "google-preview",
    "category": "SOCIAL",
    "name": "google-preview",
    "patterns": [
      "Google Web Preview"
    ],
    "forbidden": []
  },
  {
    "id": "google-web-snippet",
    "category": "SOCIAL",
    "name": "google-web-snippet",
    "patterns": [
      "developers\\.google\\.com\\/\\+\\/web\\/snippet"
    ],
    "forbidden": []
  },
  {
    "id": "groupme-crawler",
    "category": "SOCIAL",
    "name": "groupme-crawler",
    "patterns": [
      "GroupMeBot"
    ],
    "forbidden": []
  },
  {
    "id": "iframely-preview",
    "category": "SOCIAL",
    "name": "iframely-preview",
    "patterns": [
      "Iframely"
    ],
    "forbidden": []
  },
  {
    "id": "imessage-preview",
    "category": "SOCIAL",
    "name": "imessage-preview",
    "patterns": [
      "facebookexternalhit",
      "Twitterbot",
      "Facebot"
    ],
    "forbidden": []
  },
  {
    "id": "irc-archivebot",
    "category": "SOCIAL",
    "name": "ArchiveBot",
    "patterns": [
      "ArchiveBot"
    ],
    "forbidden": []
  },
  {
    "id": "keybase-bot",
    "category": "SOCIAL",
    "name": "keybase-bot",
    "patterns": [
      "KeybaseBot"
    ],
    "forbidden": []
  },
  {
    "id": "lemmy-crawler",
    "category": "SOCIAL",
    "name": "lemmy-crawler",
    "patterns": [
      "Lemmy"
    ],
    "forbidden": []
  },
  {
    "id": "linkarchiver",
    "category": "SOCIAL",
    "name": "linkarchiver",
    "patterns": [
      "LinkArchiver"
    ],
    "forbidden": []
  },
  {
    "id": "linkedin-crawler",
    "category": "SOCIAL",
    "name": "LinkedInBot",
    "patterns": [
      "LinkedInBot"
    ],
    "forbidden": []
  },
  {
    "id": "mastodon-crawler",
    "category": "SOCIAL",
    "name": "MastodonBot",
    "patterns": [
      "Mastodon"
    ],
    "forbidden": []
  },
  {
    "id": "meta-crawler-user",
    "category": "SOCIAL",
    "name": "meta-crawler-user",
    "patterns": [
      "meta-externalfetcher"
    ],
    "forbidden": []
  },
  {
    "id": "microsoft-preview",
    "category": "SOCIAL",
    "name": "microsoft-preview",
    "patterns": [
      "MicrosoftPreview\\/"
    ],
    "forbidden": []
  },
  {
    "id": "neticle-crawler",
    "category": "SOCIAL",
    "name": "neticle-crawler",
    "patterns": [
      "Neticle Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "pagepeeker-crawler",
    "category": "SOCIAL",
    "name": "pagepeeker-crawler",
    "patterns": [
      "PagePeeker\\/"
    ],
    "forbidden": []
  },
  {
    "id": "pinterest-crawler",
    "category": "SOCIAL",
    "name": "pinterest-crawler",
    "patterns": [
      "Pinterest(bot)?\\/"
    ],
    "forbidden": []
  },
  {
    "id": "pintrest-crawler",
    "category": "SOCIAL",
    "name": "PinterestBot",
    "patterns": [
      "pinterest\\.com\\/bot"
    ],
    "forbidden": []
  },
  {
    "id": "reddit-crawler",
    "category": "SOCIAL",
    "name": "RedditBot",
    "patterns": [
      "redditbot"
    ],
    "forbidden": []
  },
  {
    "id": "skype-preview",
    "category": "SOCIAL",
    "name": "skype-preview",
    "patterns": [
      "SkypeUriPreview"
    ],
    "forbidden": []
  },
  {
    "id": "slack-crawler",
    "category": "SOCIAL",
    "name": "Slackbot",
    "patterns": [
      "Slackbot"
    ],
    "forbidden": []
  },
  {
    "id": "slack-image-proxy",
    "category": "SOCIAL",
    "name": "slack-image-proxy",
    "patterns": [
      "Slack-ImgProxy"
    ],
    "forbidden": []
  },
  {
    "id": "snap-preview",
    "category": "SOCIAL",
    "name": "snap-preview",
    "patterns": [
      "Snap URL Preview Service"
    ],
    "forbidden": []
  },
  {
    "id": "steam-preview",
    "category": "SOCIAL",
    "name": "ValveSteamBot",
    "patterns": [
      "Valve\\/Steam"
    ],
    "forbidden": []
  },
  {
    "id": "stripe-webhook",
    "category": "SOCIAL",
    "name": "stripe-webhook",
    "patterns": [
      "Stripe\\/"
    ],
    "forbidden": []
  },
  {
    "id": "synapse-crawler",
    "category": "SOCIAL",
    "name": "synapse-crawler",
    "patterns": [
      "Synapse"
    ],
    "forbidden": []
  },
  {
    "id": "telegram-crawler",
    "category": "SOCIAL",
    "name": "TelegramBot",
    "patterns": [
      "TelegramBot"
    ],
    "forbidden": []
  },
  {
    "id": "tiktok-crawler",
    "category": "SOCIAL",
    "name": "tiktok-crawler",
    "patterns": [
      "TikTokSpider"
    ],
    "forbidden": []
  },
  {
    "id": "trendsmap-crawler",
    "category": "SOCIAL",
    "name": "trendsmap-crawler",
    "patterns": [
      "TrendsmapResolver"
    ],
    "forbidden": []
  },
  {
    "id": "tweetedtimes-crawler",
    "category": "SOCIAL",
    "name": "tweetedtimes-crawler",
    "patterns": [
      "tweetedtimes"
    ],
    "forbidden": []
  },
  {
    "id": "twitter-crawler",
    "category": "SOCIAL",
    "name": "Twitterbot",
    "patterns": [
      "Twitterbot"
    ],
    "forbidden": [
      "facebookexternalhit",
      "Facebot"
    ]
  },
  {
    "id": "vercel-crawler",
    "category": "SOCIAL",
    "name": "vercel-crawler",
    "patterns": [
      "Vercelbot"
    ],
    "forbidden": []
  },
  {
    "id": "vercel-monitor-preview",
    "category": "SOCIAL",
    "name": "vercel-monitor-preview",
    "patterns": [
      "vercel-screenshot"
    ],
    "forbidden": []
  },
  {
    "id": "viber-crawler",
    "category": "SOCIAL",
    "name": "ViberBot",
    "patterns": [
      "Viber"
    ],
    "forbidden": []
  },
  {
    "id": "whatsapp-crawler",
    "category": "SOCIAL",
    "name": "WhatsApp",
    "patterns": [
      "WhatsApp"
    ],
    "forbidden": []
  },
  {
    "id": "yahoo-preview",
    "category": "SOCIAL",
    "name": "yahoo-preview",
    "patterns": [
      "Yahoo Link Preview"
    ],
    "forbidden": []
  },
  {
    "id": "a6corp-crawler",
    "category": "UNKNOWN",
    "name": "a6corp-crawler",
    "patterns": [
      "A6-Indexer"
    ],
    "forbidden": []
  },
  {
    "id": "aboundex-crawler",
    "category": "UNKNOWN",
    "name": "aboundex-crawler",
    "patterns": [
      "Aboundex"
    ],
    "forbidden": []
  },
  {
    "id": "acapbot",
    "category": "UNKNOWN",
    "name": "acapbot",
    "patterns": [
      "acapbot"
    ],
    "forbidden": []
  },
  {
    "id": "acoon-crawler",
    "category": "UNKNOWN",
    "name": "acoon-crawler",
    "patterns": [
      "acoonbot"
    ],
    "forbidden": []
  },
  {
    "id": "adbeat-crawler",
    "category": "UNKNOWN",
    "name": "adbeat-crawler",
    "patterns": [
      "adbeat_bot"
    ],
    "forbidden": []
  },
  {
    "id": "addthis-crawler",
    "category": "UNKNOWN",
    "name": "addthis-crawler",
    "patterns": [
      "AddThis"
    ],
    "forbidden": []
  },
  {
    "id": "admantx-crawler",
    "category": "UNKNOWN",
    "name": "admantx-crawler",
    "patterns": [
      "ADmantX"
    ],
    "forbidden": []
  },
  {
    "id": "adscanner-crawler",
    "category": "UNKNOWN",
    "name": "adscanner-crawler",
    "patterns": [
      "adscanner"
    ],
    "forbidden": []
  },
  {
    "id": "adstxtcrawler",
    "category": "UNKNOWN",
    "name": "adstxtcrawler",
    "patterns": [
      "AdsTxtCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "advbot-crawler",
    "category": "UNKNOWN",
    "name": "advbot-crawler",
    "patterns": [
      "AdvBot"
    ],
    "forbidden": []
  },
  {
    "id": "alphaseobot-crawler",
    "category": "UNKNOWN",
    "name": "alphaseobot-crawler",
    "patterns": [
      "AlphaBot"
    ],
    "forbidden": []
  },
  {
    "id": "anderspink-crawler",
    "category": "UNKNOWN",
    "name": "anderspink-crawler",
    "patterns": [
      "AndersPinkBot"
    ],
    "forbidden": []
  },
  {
    "id": "antibot",
    "category": "UNKNOWN",
    "name": "antibot",
    "patterns": [
      "antibot"
    ],
    "forbidden": []
  },
  {
    "id": "apercite-crawler",
    "category": "UNKNOWN",
    "name": "apercite-crawler",
    "patterns": [
      "Apercite"
    ],
    "forbidden": []
  },
  {
    "id": "ara-crawler",
    "category": "UNKNOWN",
    "name": "ara-crawler",
    "patterns": [
      "arabot"
    ],
    "forbidden": []
  },
  {
    "id": "araturka-crawler",
    "category": "UNKNOWN",
    "name": "araturka-crawler",
    "patterns": [
      "Bot\\.AraTurka\\.com"
    ],
    "forbidden": []
  },
  {
    "id": "arocom-crawler",
    "category": "UNKNOWN",
    "name": "arocom-crawler",
    "patterns": [
      "drupact"
    ],
    "forbidden": []
  },
  {
    "id": "aspiegel-crawler",
    "category": "UNKNOWN",
    "name": "aspiegel-crawler",
    "patterns": [
      "AspiegelBot"
    ],
    "forbidden": []
  },
  {
    "id": "audisto-crawler",
    "category": "UNKNOWN",
    "name": "audisto-crawler",
    "patterns": [
      "Audisto Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "awario-crawler",
    "category": "UNKNOWN",
    "name": "awario-crawler",
    "patterns": [
      "AwarioBot"
    ],
    "forbidden": []
  },
  {
    "id": "awario-crawler-smart",
    "category": "UNKNOWN",
    "name": "awario-crawler-smart",
    "patterns": [
      "AwarioSmartBot"
    ],
    "forbidden": []
  },
  {
    "id": "awesomecrawler",
    "category": "UNKNOWN",
    "name": "awesomecrawler",
    "patterns": [
      "awesomecrawler"
    ],
    "forbidden": []
  },
  {
    "id": "b2bbot",
    "category": "UNKNOWN",
    "name": "b2bbot",
    "patterns": [
      "B2B Bot"
    ],
    "forbidden": []
  },
  {
    "id": "backlinktest-crawler",
    "category": "UNKNOWN",
    "name": "backlinktest-crawler",
    "patterns": [
      "backlinkcrawler"
    ],
    "forbidden": []
  },
  {
    "id": "baidu-cloud-watch",
    "category": "UNKNOWN",
    "name": "baidu-cloud-watch",
    "patterns": [
      "Baidu-YunGuanCe"
    ],
    "forbidden": []
  },
  {
    "id": "betabot",
    "category": "UNKNOWN",
    "name": "betabot",
    "patterns": [
      "betaBot"
    ],
    "forbidden": []
  },
  {
    "id": "bidswitch-crawler",
    "category": "UNKNOWN",
    "name": "bidswitch-crawler",
    "patterns": [
      "bidswitchbot"
    ],
    "forbidden": []
  },
  {
    "id": "bigdatacorp-crawler",
    "category": "UNKNOWN",
    "name": "bigdatacorp-crawler",
    "patterns": [
      "BDCbot"
    ],
    "forbidden": []
  },
  {
    "id": "biglotron",
    "category": "UNKNOWN",
    "name": "biglotron",
    "patterns": [
      "BIGLOTRON"
    ],
    "forbidden": []
  },
  {
    "id": "binlar",
    "category": "UNKNOWN",
    "name": "binlar",
    "patterns": [
      "binlar"
    ],
    "forbidden": []
  },
  {
    "id": "bitsight-crawler",
    "category": "UNKNOWN",
    "name": "bitsight-crawler",
    "patterns": [
      "BitSightBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "blogmura-crawler",
    "category": "UNKNOWN",
    "name": "blogmura-crawler",
    "patterns": [
      "blogmuraBot"
    ],
    "forbidden": []
  },
  {
    "id": "blp-bbot",
    "category": "UNKNOWN",
    "name": "blp-bbot",
    "patterns": [
      "BLP_bbot"
    ],
    "forbidden": []
  },
  {
    "id": "bnf-crawler",
    "category": "UNKNOWN",
    "name": "bnf-crawler",
    "patterns": [
      "bnf\\.fr_bot"
    ],
    "forbidden": []
  },
  {
    "id": "bombora-crawler",
    "category": "UNKNOWN",
    "name": "bombora-crawler",
    "patterns": [
      "BomboraBot"
    ],
    "forbidden": []
  },
  {
    "id": "boxcar-crawler",
    "category": "UNKNOWN",
    "name": "boxcar-crawler",
    "patterns": [
      "BoxcarBot"
    ],
    "forbidden": []
  },
  {
    "id": "brainobot",
    "category": "UNKNOWN",
    "name": "brainobot",
    "patterns": [
      "brainobot"
    ],
    "forbidden": []
  },
  {
    "id": "brandonmedia-crawler",
    "category": "UNKNOWN",
    "name": "brandonmedia-crawler",
    "patterns": [
      "BrandONbot"
    ],
    "forbidden": []
  },
  {
    "id": "brandwatch-crawler",
    "category": "UNKNOWN",
    "name": "brandwatch-crawler",
    "patterns": [
      "magpie-crawler"
    ],
    "forbidden": []
  },
  {
    "id": "brightedge-crawler",
    "category": "UNKNOWN",
    "name": "brightedge-crawler",
    "patterns": [
      "BrightEdge Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "bublup-crawler",
    "category": "UNKNOWN",
    "name": "bublup-crawler",
    "patterns": [
      "BublupBot"
    ],
    "forbidden": []
  },
  {
    "id": "builtwith-crawler",
    "category": "UNKNOWN",
    "name": "builtwith-crawler",
    "patterns": [
      "^BW\\/"
    ],
    "forbidden": []
  },
  {
    "id": "buzzstream-crawler",
    "category": "UNKNOWN",
    "name": "buzzstream-crawler",
    "patterns": [
      "buzzbot"
    ],
    "forbidden": []
  },
  {
    "id": "capsulink-crawler",
    "category": "UNKNOWN",
    "name": "capsulink-crawler",
    "patterns": [
      "CapsuleChecker"
    ],
    "forbidden": []
  },
  {
    "id": "careerx-crawler",
    "category": "UNKNOWN",
    "name": "careerx-crawler",
    "patterns": [
      "careerbot"
    ],
    "forbidden": []
  },
  {
    "id": "centurybot",
    "category": "UNKNOWN",
    "name": "centurybot",
    "patterns": [
      "centurybot"
    ],
    "forbidden": []
  },
  {
    "id": "checkmarknetwork-crawler",
    "category": "UNKNOWN",
    "name": "checkmarknetwork-crawler",
    "patterns": [
      "CheckMarkNetwork\\/"
    ],
    "forbidden": []
  },
  {
    "id": "chlooe-crawler",
    "category": "UNKNOWN",
    "name": "chlooe-crawler",
    "patterns": [
      "bot-pge\\.chlooe\\.com"
    ],
    "forbidden": []
  },
  {
    "id": "cincrawdata-crawler",
    "category": "UNKNOWN",
    "name": "cincrawdata-crawler",
    "patterns": [
      "Cincraw"
    ],
    "forbidden": []
  },
  {
    "id": "citeseerx-crawler",
    "category": "UNKNOWN",
    "name": "citeseerx-crawler",
    "patterns": [
      "citeseerxbot"
    ],
    "forbidden": []
  },
  {
    "id": "clickagy-crawler",
    "category": "UNKNOWN",
    "name": "clickagy-crawler",
    "patterns": [
      "Clickagy"
    ],
    "forbidden": []
  },
  {
    "id": "cliqz-crawler",
    "category": "UNKNOWN",
    "name": "cliqz-crawler",
    "patterns": [
      "Cliqzbot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "cloudsystemnetworks-crawler",
    "category": "UNKNOWN",
    "name": "cloudsystemnetworks-crawler",
    "patterns": [
      "Nimbostratus-Bot"
    ],
    "forbidden": []
  },
  {
    "id": "coccoc-crawler",
    "category": "UNKNOWN",
    "name": "coccoc-crawler",
    "patterns": [
      "coccoc"
    ],
    "forbidden": []
  },
  {
    "id": "cocolyze-crawler",
    "category": "UNKNOWN",
    "name": "cocolyze-crawler",
    "patterns": [
      "Cocolyzebot"
    ],
    "forbidden": []
  },
  {
    "id": "codewise-crawler",
    "category": "UNKNOWN",
    "name": "codewise-crawler",
    "patterns": [
      "VoluumDSP-content-bot"
    ],
    "forbidden": []
  },
  {
    "id": "cognitiveseo-crawler",
    "category": "UNKNOWN",
    "name": "cognitiveseo-crawler",
    "patterns": [
      "James BOT"
    ],
    "forbidden": []
  },
  {
    "id": "companybook-crawler",
    "category": "UNKNOWN",
    "name": "companybook-crawler",
    "patterns": [
      "Companybook-Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "content-crawler-spider",
    "category": "UNKNOWN",
    "name": "content-crawler-spider",
    "patterns": [
      "content crawler spider"
    ],
    "forbidden": []
  },
  {
    "id": "contextad-crawler",
    "category": "UNKNOWN",
    "name": "contextad-crawler",
    "patterns": [
      "ContextAd Bot"
    ],
    "forbidden": []
  },
  {
    "id": "contxbot",
    "category": "UNKNOWN",
    "name": "contxbot",
    "patterns": [
      "contxbot"
    ],
    "forbidden": []
  },
  {
    "id": "convera-crawler",
    "category": "UNKNOWN",
    "name": "convera-crawler",
    "patterns": [
      "convera"
    ],
    "forbidden": []
  },
  {
    "id": "cookiebot-crawler",
    "category": "UNKNOWN",
    "name": "cookiebot-crawler",
    "patterns": [
      "Cookiebot"
    ],
    "forbidden": []
  },
  {
    "id": "creativecommons-crawler",
    "category": "UNKNOWN",
    "name": "creativecommons-crawler",
    "patterns": [
      "CC Metadata Scaper"
    ],
    "forbidden": []
  },
  {
    "id": "criteo-crawler",
    "category": "UNKNOWN",
    "name": "criteo-crawler",
    "patterns": [
      "CriteoBot"
    ],
    "forbidden": []
  },
  {
    "id": "crystalsemantics-crawler",
    "category": "UNKNOWN",
    "name": "crystalsemantics-crawler",
    "patterns": [
      "CrystalSemanticsBot"
    ],
    "forbidden": []
  },
  {
    "id": "curebot-crawler",
    "category": "UNKNOWN",
    "name": "curebot-crawler",
    "patterns": [
      "[Cc]urebot"
    ],
    "forbidden": []
  },
  {
    "id": "cutbot-crawler",
    "category": "UNKNOWN",
    "name": "cutbot-crawler",
    "patterns": [
      "Cutbot"
    ],
    "forbidden": []
  },
  {
    "id": "cxense-crawler",
    "category": "UNKNOWN",
    "name": "cxense-crawler",
    "patterns": [
      "cXensebot"
    ],
    "forbidden": []
  },
  {
    "id": "cyberpatrol-crawler",
    "category": "UNKNOWN",
    "name": "cyberpatrol-crawler",
    "patterns": [
      "CyberPatrol"
    ],
    "forbidden": []
  },
  {
    "id": "datafeedwatch-crawler",
    "category": "UNKNOWN",
    "name": "datafeedwatch-crawler",
    "patterns": [
      "Datafeedwatch"
    ],
    "forbidden": []
  },
  {
    "id": "dataforseo-crawler",
    "category": "UNKNOWN",
    "name": "dataforseo-crawler",
    "patterns": [
      "DataForSeoBot"
    ],
    "forbidden": []
  },
  {
    "id": "datagnion-crawler",
    "category": "UNKNOWN",
    "name": "datagnion-crawler",
    "patterns": [
      "datagnionbot"
    ],
    "forbidden": []
  },
  {
    "id": "datanyze-crawler",
    "category": "UNKNOWN",
    "name": "datanyze-crawler",
    "patterns": [
      "Datanyze"
    ],
    "forbidden": []
  },
  {
    "id": "dataprovider-crawler",
    "category": "UNKNOWN",
    "name": "dataprovider-crawler",
    "patterns": [
      "Dataprovider\\.com"
    ],
    "forbidden": []
  },
  {
    "id": "datenbutler-crawler",
    "category": "UNKNOWN",
    "name": "datenbutler-crawler",
    "patterns": [
      "mindUpBot"
    ],
    "forbidden": []
  },
  {
    "id": "daum-crawler",
    "category": "UNKNOWN",
    "name": "daum-crawler",
    "patterns": [
      "Daum\\/"
    ],
    "forbidden": []
  },
  {
    "id": "deepnoc-crawler",
    "category": "UNKNOWN",
    "name": "deepnoc-crawler",
    "patterns": [
      "deepnoc"
    ],
    "forbidden": []
  },
  {
    "id": "deusu-crawler",
    "category": "UNKNOWN",
    "name": "deusu-crawler",
    "patterns": [
      "DeuSu\\/"
    ],
    "forbidden": []
  },
  {
    "id": "digincore-crawler",
    "category": "UNKNOWN",
    "name": "digincore-crawler",
    "patterns": [
      "Digincore bot"
    ],
    "forbidden": []
  },
  {
    "id": "digitaldragon-crawler",
    "category": "UNKNOWN",
    "name": "digitaldragon-crawler",
    "patterns": [
      "CrawlyProjectCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "discoveryengine-crawler",
    "category": "UNKNOWN",
    "name": "discoveryengine-crawler",
    "patterns": [
      "discobot"
    ],
    "forbidden": []
  },
  {
    "id": "dnyz-crawler",
    "category": "UNKNOWN",
    "name": "dnyz-crawler",
    "patterns": [
      "DnyzBot"
    ],
    "forbidden": []
  },
  {
    "id": "domaincrawler-crawler",
    "category": "UNKNOWN",
    "name": "domaincrawler-crawler",
    "patterns": [
      "domaincrawler"
    ],
    "forbidden": []
  },
  {
    "id": "domainreanimator-crawler",
    "category": "UNKNOWN",
    "name": "domainreanimator-crawler",
    "patterns": [
      "Domain Re-Animator Bot"
    ],
    "forbidden": []
  },
  {
    "id": "domainsbot-crawler",
    "category": "UNKNOWN",
    "name": "domainsbot-crawler",
    "patterns": [
      "Pandalytics"
    ],
    "forbidden": []
  },
  {
    "id": "domainstats-crawler",
    "category": "UNKNOWN",
    "name": "domainstats-crawler",
    "patterns": [
      "DomainStatsBot"
    ],
    "forbidden": []
  },
  {
    "id": "domaintools-crawler",
    "category": "UNKNOWN",
    "name": "domaintools-crawler",
    "patterns": [
      "SurveyBot"
    ],
    "forbidden": []
  },
  {
    "id": "dotnetdotcom-crawler",
    "category": "UNKNOWN",
    "name": "dotnetdotcom-crawler",
    "patterns": [
      "ezooms"
    ],
    "forbidden": []
  },
  {
    "id": "dragonmetrics-crawler",
    "category": "UNKNOWN",
    "name": "dragonmetrics-crawler",
    "patterns": [
      "Dragonbot"
    ],
    "forbidden": []
  },
  {
    "id": "driftnet-crawler",
    "category": "UNKNOWN",
    "name": "driftnet-crawler",
    "patterns": [
      "InternetMeasurement"
    ],
    "forbidden": []
  },
  {
    "id": "duedil-crawler",
    "category": "UNKNOWN",
    "name": "duedil-crawler",
    "patterns": [
      "electricmonk"
    ],
    "forbidden": []
  },
  {
    "id": "ec2linkfinder",
    "category": "UNKNOWN",
    "name": "ec2linkfinder",
    "patterns": [
      "ec2linkfinder"
    ],
    "forbidden": []
  },
  {
    "id": "edister-crawler",
    "category": "UNKNOWN",
    "name": "edister-crawler",
    "patterns": [
      "edisterbot"
    ],
    "forbidden": []
  },
  {
    "id": "elisabot",
    "category": "UNKNOWN",
    "name": "elisabot",
    "patterns": [
      "elisabot"
    ],
    "forbidden": []
  },
  {
    "id": "epictions-crawler",
    "category": "UNKNOWN",
    "name": "epictions-crawler",
    "patterns": [
      "epicbot"
    ],
    "forbidden": []
  },
  {
    "id": "eright-crawler",
    "category": "UNKNOWN",
    "name": "eright-crawler",
    "patterns": [
      "eright"
    ],
    "forbidden": []
  },
  {
    "id": "europarchive-crawler",
    "category": "UNKNOWN",
    "name": "europarchive-crawler",
    "patterns": [
      "europarchive\\.org"
    ],
    "forbidden": []
  },
  {
    "id": "eventures-crawler",
    "category": "UNKNOWN",
    "name": "eventures-crawler",
    "patterns": [
      "e\\.ventures Investment Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "eventures-crawler-batch",
    "category": "UNKNOWN",
    "name": "eventures-crawler-batch",
    "patterns": [
      "evc-batch"
    ],
    "forbidden": []
  },
  {
    "id": "exensa-crawler",
    "category": "UNKNOWN",
    "name": "exensa-crawler",
    "patterns": [
      "Bark[rR]owler"
    ],
    "forbidden": []
  },
  {
    "id": "experibot-crawler",
    "category": "UNKNOWN",
    "name": "experibot-crawler",
    "patterns": [
      "Experibot"
    ],
    "forbidden": []
  },
  {
    "id": "extlinks-crawler",
    "category": "UNKNOWN",
    "name": "extlinks-crawler",
    "patterns": [
      "ExtLinksBot"
    ],
    "forbidden": []
  },
  {
    "id": "eyeota-crawler",
    "category": "UNKNOWN",
    "name": "eyeota-crawler",
    "patterns": [
      "Eyeotabot"
    ],
    "forbidden": []
  },
  {
    "id": "fast-crawler",
    "category": "UNKNOWN",
    "name": "fast-crawler",
    "patterns": [
      "FAST-WebCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "fast-crawler-enterprise",
    "category": "UNKNOWN",
    "name": "fast-crawler-enterprise",
    "patterns": [
      "FAST Enterprise Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "fedoraplanet-crawler",
    "category": "UNKNOWN",
    "name": "fedoraplanet-crawler",
    "patterns": [
      "fedoraplanet"
    ],
    "forbidden": []
  },
  {
    "id": "feedafever-crawler",
    "category": "UNKNOWN",
    "name": "feedafever-crawler",
    "patterns": [
      "Fever"
    ],
    "forbidden": []
  },
  {
    "id": "femtosearch-crawler",
    "category": "UNKNOWN",
    "name": "femtosearch-crawler",
    "patterns": [
      "FemtosearchBot"
    ],
    "forbidden": []
  },
  {
    "id": "findthatfile-crawler",
    "category": "UNKNOWN",
    "name": "findthatfile-crawler",
    "patterns": [
      "findthatfile"
    ],
    "forbidden": []
  },
  {
    "id": "flamingosearch-crawler",
    "category": "UNKNOWN",
    "name": "flamingosearch-crawler",
    "patterns": [
      "Flamingo_SearchEngine"
    ],
    "forbidden": []
  },
  {
    "id": "fluffy",
    "category": "UNKNOWN",
    "name": "fluffy",
    "patterns": [
      "fluffy"
    ],
    "forbidden": []
  },
  {
    "id": "fr-crawler",
    "category": "UNKNOWN",
    "name": "fr-crawler",
    "patterns": [
      "fr-crawler"
    ],
    "forbidden": []
  },
  {
    "id": "fuelbot",
    "category": "UNKNOWN",
    "name": "fuelbot",
    "patterns": [
      "fuelbot"
    ],
    "forbidden": []
  },
  {
    "id": "fyrebot",
    "category": "UNKNOWN",
    "name": "fyrebot",
    "patterns": [
      "Fyrebot"
    ],
    "forbidden": []
  },
  {
    "id": "g00g1e-crawler",
    "category": "UNKNOWN",
    "name": "g00g1e-crawler",
    "patterns": [
      "g00g1e\\.net"
    ],
    "forbidden": []
  },
  {
    "id": "g2webservices-crawler",
    "category": "UNKNOWN",
    "name": "g2webservices-crawler",
    "patterns": [
      "G2 Web Services"
    ],
    "forbidden": []
  },
  {
    "id": "garlik-crawler",
    "category": "UNKNOWN",
    "name": "garlik-crawler",
    "patterns": [
      "GarlikCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "genieo-crawler",
    "category": "UNKNOWN",
    "name": "genieo-crawler",
    "patterns": [
      "Genieo"
    ],
    "forbidden": []
  },
  {
    "id": "gigablast-crawler",
    "category": "UNKNOWN",
    "name": "gigablast-crawler",
    "patterns": [
      "Gigabot"
    ],
    "forbidden": []
  },
  {
    "id": "ginger-crawler",
    "category": "UNKNOWN",
    "name": "ginger-crawler",
    "patterns": [
      "GingerCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "gnam-gnam-spider",
    "category": "UNKNOWN",
    "name": "gnam-gnam-spider",
    "patterns": [
      "gnam gnam spider"
    ],
    "forbidden": []
  },
  {
    "id": "gnowit-crawler",
    "category": "UNKNOWN",
    "name": "gnowit-crawler",
    "patterns": [
      "GnowitNewsbot"
    ],
    "forbidden": []
  },
  {
    "id": "goo-crawler",
    "category": "UNKNOWN",
    "name": "goo-crawler",
    "patterns": [
      "ichiro"
    ],
    "forbidden": []
  },
  {
    "id": "grapeshot-crawler",
    "category": "UNKNOWN",
    "name": "grapeshot-crawler",
    "patterns": [
      "GrapeshotCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "grob-crawler",
    "category": "UNKNOWN",
    "name": "grob-crawler",
    "patterns": [
      "Grobbot"
    ],
    "forbidden": []
  },
  {
    "id": "grouphigh-crawler",
    "category": "UNKNOWN",
    "name": "grouphigh-crawler",
    "patterns": [
      "GroupHigh\\/"
    ],
    "forbidden": []
  },
  {
    "id": "grub",
    "category": "UNKNOWN",
    "name": "grub",
    "patterns": [
      "grub\\.org"
    ],
    "forbidden": []
  },
  {
    "id": "gslfbot",
    "category": "UNKNOWN",
    "name": "gslfbot",
    "patterns": [
      "gslfbot"
    ],
    "forbidden": []
  },
  {
    "id": "gwene-crawler",
    "category": "UNKNOWN",
    "name": "gwene-crawler",
    "patterns": [
      "Gwene"
    ],
    "forbidden": []
  },
  {
    "id": "haosou-crawler",
    "category": "UNKNOWN",
    "name": "haosou-crawler",
    "patterns": [
      "360Spider"
    ],
    "forbidden": []
  },
  {
    "id": "hatena-crawler",
    "category": "UNKNOWN",
    "name": "hatena-crawler",
    "patterns": [
      "Hatena"
    ],
    "forbidden": []
  },
  {
    "id": "headline-crawler",
    "category": "UNKNOWN",
    "name": "headline-crawler",
    "patterns": [
      "ev-crawler\\/"
    ],
    "forbidden": []
  },
  {
    "id": "hoyer-crawler",
    "category": "UNKNOWN",
    "name": "hoyer-crawler",
    "patterns": [
      "Friendica"
    ],
    "forbidden": []
  },
  {
    "id": "httrack",
    "category": "UNKNOWN",
    "name": "httrack",
    "patterns": [
      "HTTrack"
    ],
    "forbidden": []
  },
  {
    "id": "hypefactors-crawler",
    "category": "UNKNOWN",
    "name": "hypefactors-crawler",
    "patterns": [
      "Buck\\/"
    ],
    "forbidden": []
  },
  {
    "id": "hypestat-crawler",
    "category": "UNKNOWN",
    "name": "hypestat-crawler",
    "patterns": [
      "hypestat"
    ],
    "forbidden": []
  },
  {
    "id": "hyscore-crawler",
    "category": "UNKNOWN",
    "name": "hyscore-crawler",
    "patterns": [
      "hyscore\\.io"
    ],
    "forbidden": []
  },
  {
    "id": "ia-archiver",
    "category": "UNKNOWN",
    "name": "ia-archiver",
    "patterns": [
      "ia_archiver"
    ],
    "forbidden": []
  },
  {
    "id": "ideasandcode-crawler",
    "category": "UNKNOWN",
    "name": "ideasandcode-crawler",
    "patterns": [
      "ICBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "indeed-crawler",
    "category": "UNKNOWN",
    "name": "indeed-crawler",
    "patterns": [
      "IndeedBot"
    ],
    "forbidden": []
  },
  {
    "id": "inetdex-crawler",
    "category": "UNKNOWN",
    "name": "inetdex-crawler",
    "patterns": [
      "INETDEX-BOT"
    ],
    "forbidden": []
  },
  {
    "id": "infoo-crawler",
    "category": "UNKNOWN",
    "name": "infoo-crawler",
    "patterns": [
      "infoobot"
    ],
    "forbidden": []
  },
  {
    "id": "integromedb-crawler",
    "category": "UNKNOWN",
    "name": "integromedb-crawler",
    "patterns": [
      "integromedb"
    ],
    "forbidden": []
  },
  {
    "id": "intelium-crawler",
    "category": "UNKNOWN",
    "name": "intelium-crawler",
    "patterns": [
      "intelium_bot"
    ],
    "forbidden": []
  },
  {
    "id": "ionos-crawler",
    "category": "UNKNOWN",
    "name": "ionos-crawler",
    "patterns": [
      "IonCrawl"
    ],
    "forbidden": []
  },
  {
    "id": "ip-web-crawler",
    "category": "UNKNOWN",
    "name": "ip-web-crawler",
    "patterns": [
      "ip-web-crawler\\.com"
    ],
    "forbidden": []
  },
  {
    "id": "iskanie-crawler",
    "category": "UNKNOWN",
    "name": "iskanie-crawler",
    "patterns": [
      "iskanie"
    ],
    "forbidden": []
  },
  {
    "id": "iss-crawler",
    "category": "UNKNOWN",
    "name": "iss-crawler",
    "patterns": [
      "filterdb\\.iss\\.net\\/crawler"
    ],
    "forbidden": []
  },
  {
    "id": "it2media-crawler",
    "category": "UNKNOWN",
    "name": "it2media-crawler",
    "patterns": [
      "it2media-domain-crawler"
    ],
    "forbidden": []
  },
  {
    "id": "itinfluentials-crawler",
    "category": "UNKNOWN",
    "name": "itinfluentials-crawler",
    "patterns": [
      "FindITAnswersbot"
    ],
    "forbidden": []
  },
  {
    "id": "jamiembrown-crawler",
    "category": "UNKNOWN",
    "name": "jamiembrown-crawler",
    "patterns": [
      "Jamie's Spider"
    ],
    "forbidden": []
  },
  {
    "id": "jetslide-crawler",
    "category": "UNKNOWN",
    "name": "jetslide-crawler",
    "patterns": [
      "Jetslide"
    ],
    "forbidden": []
  },
  {
    "id": "jobboerse-crawler",
    "category": "UNKNOWN",
    "name": "jobboerse-crawler",
    "patterns": [
      "JobboerseBot"
    ],
    "forbidden": []
  },
  {
    "id": "jooble-crawler",
    "category": "UNKNOWN",
    "name": "jooble-crawler",
    "patterns": [
      "Jooblebot"
    ],
    "forbidden": []
  },
  {
    "id": "jusprog-crawler",
    "category": "UNKNOWN",
    "name": "jusprog-crawler",
    "patterns": [
      "Jugendschutzprogramm-Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "jyxo-crawler",
    "category": "UNKNOWN",
    "name": "jyxo-crawler",
    "patterns": [
      "jyxobot"
    ],
    "forbidden": []
  },
  {
    "id": "k7computing-crawler",
    "category": "UNKNOWN",
    "name": "k7computing-crawler",
    "patterns": [
      "K7MLWCBot"
    ],
    "forbidden": []
  },
  {
    "id": "kemvi-crawler",
    "category": "UNKNOWN",
    "name": "kemvi-crawler",
    "patterns": [
      "Kemvibot"
    ],
    "forbidden": []
  },
  {
    "id": "komodia-crawler",
    "category": "UNKNOWN",
    "name": "komodia-crawler",
    "patterns": [
      "KomodiaBot"
    ],
    "forbidden": []
  },
  {
    "id": "kosmio-crawler",
    "category": "UNKNOWN",
    "name": "kosmio-crawler",
    "patterns": [
      "KosmioBot"
    ],
    "forbidden": []
  },
  {
    "id": "landaumedia-crawler",
    "category": "UNKNOWN",
    "name": "landaumedia-crawler",
    "patterns": [
      "Landau-Media-Spider"
    ],
    "forbidden": []
  },
  {
    "id": "laserlike-crawler",
    "category": "UNKNOWN",
    "name": "laserlike-crawler",
    "patterns": [
      "Laserlikebot"
    ],
    "forbidden": []
  },
  {
    "id": "lb-spider",
    "category": "UNKNOWN",
    "name": "lb-spider",
    "patterns": [
      "lb-spider"
    ],
    "forbidden": []
  },
  {
    "id": "leiki-crawler",
    "category": "UNKNOWN",
    "name": "leiki-crawler",
    "patterns": [
      "Leikibot"
    ],
    "forbidden": []
  },
  {
    "id": "lightspeedsystems-crawler",
    "category": "UNKNOWN",
    "name": "lightspeedsystems-crawler",
    "patterns": [
      "LightspeedSystemsCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "line-crawler",
    "category": "UNKNOWN",
    "name": "line-crawler",
    "patterns": [
      "Linespider"
    ],
    "forbidden": []
  },
  {
    "id": "linkapedia-crawler",
    "category": "UNKNOWN",
    "name": "linkapedia-crawler",
    "patterns": [
      "linkapediabot"
    ],
    "forbidden": []
  },
  {
    "id": "linkdex-crawler",
    "category": "UNKNOWN",
    "name": "linkdex-crawler",
    "patterns": [
      "linkdex"
    ],
    "forbidden": []
  },
  {
    "id": "linkfluence-crawler",
    "category": "UNKNOWN",
    "name": "linkfluence-crawler",
    "patterns": [
      "YaK\\/"
    ],
    "forbidden": []
  },
  {
    "id": "linkis-crawler",
    "category": "UNKNOWN",
    "name": "linkis-crawler",
    "patterns": [
      "LinkisBot"
    ],
    "forbidden": []
  },
  {
    "id": "lipperhey-crawler",
    "category": "UNKNOWN",
    "name": "lipperhey-crawler",
    "patterns": [
      "lipperhey"
    ],
    "forbidden": []
  },
  {
    "id": "livelap-crawler",
    "category": "UNKNOWN",
    "name": "livelap-crawler",
    "patterns": [
      "Livelap[bB]ot"
    ],
    "forbidden": []
  },
  {
    "id": "logly-crawler",
    "category": "UNKNOWN",
    "name": "logly-crawler",
    "patterns": [
      "zenback bot"
    ],
    "forbidden": []
  },
  {
    "id": "loop-crawler",
    "category": "UNKNOWN",
    "name": "loop-crawler",
    "patterns": [
      "netresearchserver"
    ],
    "forbidden": []
  },
  {
    "id": "lssbot",
    "category": "UNKNOWN",
    "name": "lssbot",
    "patterns": [
      "lssbot"
    ],
    "forbidden": []
  },
  {
    "id": "lssbot-rocket",
    "category": "UNKNOWN",
    "name": "lssbot-rocket",
    "patterns": [
      "lssrocketcrawler"
    ],
    "forbidden": []
  },
  {
    "id": "ltx71-crawler",
    "category": "UNKNOWN",
    "name": "ltx71-crawler",
    "patterns": [
      "ltx71"
    ],
    "forbidden": []
  },
  {
    "id": "luminator-crawler",
    "category": "UNKNOWN",
    "name": "luminator-crawler",
    "patterns": [
      "Luminator-robots"
    ],
    "forbidden": []
  },
  {
    "id": "mailru-crawler",
    "category": "UNKNOWN",
    "name": "MailRuBot",
    "patterns": [
      "Mail\\.RU_Bot"
    ],
    "forbidden": []
  },
  {
    "id": "mappydata-crawler",
    "category": "UNKNOWN",
    "name": "mappydata-crawler",
    "patterns": [
      "mappydata"
    ],
    "forbidden": []
  },
  {
    "id": "mauibot",
    "category": "UNKNOWN",
    "name": "mauibot",
    "patterns": [
      "MauiBot"
    ],
    "forbidden": []
  },
  {
    "id": "megaindex-crawler",
    "category": "UNKNOWN",
    "name": "megaindex-crawler",
    "patterns": [
      "MegaIndex"
    ],
    "forbidden": []
  },
  {
    "id": "meltwater-crawler",
    "category": "UNKNOWN",
    "name": "meltwater-crawler",
    "patterns": [
      "MeltwaterNews"
    ],
    "forbidden": []
  },
  {
    "id": "metadatalabs-crawler",
    "category": "UNKNOWN",
    "name": "metadatalabs-crawler",
    "patterns": [
      "mlbot"
    ],
    "forbidden": []
  },
  {
    "id": "metajob-crawler",
    "category": "UNKNOWN",
    "name": "metajob-crawler",
    "patterns": [
      "MetaJobBot"
    ],
    "forbidden": []
  },
  {
    "id": "metauri-crawler",
    "category": "UNKNOWN",
    "name": "metauri-crawler",
    "patterns": [
      "MetaURI"
    ],
    "forbidden": []
  },
  {
    "id": "metricstools-crawler",
    "category": "UNKNOWN",
    "name": "metricstools-crawler",
    "patterns": [
      "MTRobot"
    ],
    "forbidden": []
  },
  {
    "id": "mignify-crawler",
    "category": "UNKNOWN",
    "name": "mignify-crawler",
    "patterns": [
      "memorybot"
    ],
    "forbidden": []
  },
  {
    "id": "mignify-imrbot",
    "category": "UNKNOWN",
    "name": "mignify-imrbot",
    "patterns": [
      "imrbot"
    ],
    "forbidden": []
  },
  {
    "id": "mixnode-cache",
    "category": "UNKNOWN",
    "name": "mixnode-cache",
    "patterns": [
      "MixnodeCache\\/"
    ],
    "forbidden": []
  },
  {
    "id": "moodle-crawler",
    "category": "UNKNOWN",
    "name": "moodle-crawler",
    "patterns": [
      "MoodleBot"
    ],
    "forbidden": []
  },
  {
    "id": "moreover-crawler",
    "category": "UNKNOWN",
    "name": "moreover-crawler",
    "patterns": [
      "Moreover"
    ],
    "forbidden": []
  },
  {
    "id": "moz-crawler",
    "category": "UNKNOWN",
    "name": "moz-crawler",
    "patterns": [
      "dotbot"
    ],
    "forbidden": []
  },
  {
    "id": "muckrack-crawler",
    "category": "UNKNOWN",
    "name": "muckrack-crawler",
    "patterns": [
      "MuckRack"
    ],
    "forbidden": []
  },
  {
    "id": "multiviewbot",
    "category": "UNKNOWN",
    "name": "multiviewbot",
    "patterns": [
      "Multiviewbot"
    ],
    "forbidden": []
  },
  {
    "id": "naver-crawler",
    "category": "UNKNOWN",
    "name": "naver-crawler",
    "patterns": [
      "Yeti"
    ],
    "forbidden": []
  },
  {
    "id": "neeva-crawler",
    "category": "UNKNOWN",
    "name": "neeva-crawler",
    "patterns": [
      "Neevabot"
    ],
    "forbidden": []
  },
  {
    "id": "nerdbynature-crawler",
    "category": "UNKNOWN",
    "name": "nerdbynature-crawler",
    "patterns": [
      "NerdByNature\\.Bot"
    ],
    "forbidden": []
  },
  {
    "id": "nerdybot-crawler",
    "category": "UNKNOWN",
    "name": "nerdybot-crawler",
    "patterns": [
      "nerdybot"
    ],
    "forbidden": []
  },
  {
    "id": "netcraft-crawler",
    "category": "UNKNOWN",
    "name": "netcraft-crawler",
    "patterns": [
      "NetcraftSurveyAgent"
    ],
    "forbidden": []
  },
  {
    "id": "netsystemsresearch-crawler",
    "category": "UNKNOWN",
    "name": "netsystemsresearch-crawler",
    "patterns": [
      "NetSystemsResearch"
    ],
    "forbidden": []
  },
  {
    "id": "netvibes-crawler",
    "category": "UNKNOWN",
    "name": "netvibes-crawler",
    "patterns": [
      "Netvibes"
    ],
    "forbidden": []
  },
  {
    "id": "newsharecounts-crawler",
    "category": "UNKNOWN",
    "name": "newsharecounts-crawler",
    "patterns": [
      "newsharecounts"
    ],
    "forbidden": []
  },
  {
    "id": "newspaper",
    "category": "UNKNOWN",
    "name": "newspaper",
    "patterns": [
      "newspaper\\/"
    ],
    "forbidden": []
  },
  {
    "id": "nextcloud-crawler",
    "category": "UNKNOWN",
    "name": "NextCloudBot",
    "patterns": [
      "NextCloud"
    ],
    "forbidden": []
  },
  {
    "id": "niki-bot",
    "category": "UNKNOWN",
    "name": "niki-bot",
    "patterns": [
      "niki-bot"
    ],
    "forbidden": []
  },
  {
    "id": "ning-crawler",
    "category": "UNKNOWN",
    "name": "ning-crawler",
    "patterns": [
      "NING\\/"
    ],
    "forbidden": []
  },
  {
    "id": "ninjabot",
    "category": "UNKNOWN",
    "name": "ninjabot",
    "patterns": [
      "NINJA bot"
    ],
    "forbidden": []
  },
  {
    "id": "nuzzel-crawler",
    "category": "UNKNOWN",
    "name": "nuzzel-crawler",
    "patterns": [
      "Nuzzel"
    ],
    "forbidden": []
  },
  {
    "id": "ocarinabot",
    "category": "UNKNOWN",
    "name": "ocarinabot",
    "patterns": [
      "Ocarinabot"
    ],
    "forbidden": []
  },
  {
    "id": "okru-crawler",
    "category": "UNKNOWN",
    "name": "okru-crawler",
    "patterns": [
      "OdklBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "opengraphcheck-crawler",
    "category": "UNKNOWN",
    "name": "opengraphcheck-crawler",
    "patterns": [
      "OpenGraphCheck"
    ],
    "forbidden": []
  },
  {
    "id": "openhose-crawler",
    "category": "UNKNOWN",
    "name": "openhose-crawler",
    "patterns": [
      "OpenHoseBot"
    ],
    "forbidden": []
  },
  {
    "id": "openindex-crawler",
    "category": "UNKNOWN",
    "name": "openindex-crawler",
    "patterns": [
      "openindexspider"
    ],
    "forbidden": []
  },
  {
    "id": "orange-crawler",
    "category": "UNKNOWN",
    "name": "orange-crawler",
    "patterns": [
      "OrangeBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "orange-ftgroup-crawler",
    "category": "UNKNOWN",
    "name": "orange-ftgroup-crawler",
    "patterns": [
      "voilabot"
    ],
    "forbidden": []
  },
  {
    "id": "outclicks-crawler",
    "category": "UNKNOWN",
    "name": "outclicks-crawler",
    "patterns": [
      "OutclicksBot"
    ],
    "forbidden": []
  },
  {
    "id": "page-to-rss",
    "category": "UNKNOWN",
    "name": "page-to-rss",
    "patterns": [
      "page2rss"
    ],
    "forbidden": []
  },
  {
    "id": "pagething-crawler",
    "category": "UNKNOWN",
    "name": "pagething-crawler",
    "patterns": [
      "PageThing"
    ],
    "forbidden": []
  },
  {
    "id": "paloaltonetworks-crawler",
    "category": "UNKNOWN",
    "name": "paloaltonetworks-crawler",
    "patterns": [
      "Expanse"
    ],
    "forbidden": []
  },
  {
    "id": "panscient-crawler",
    "category": "UNKNOWN",
    "name": "panscient-crawler",
    "patterns": [
      "panscient"
    ],
    "forbidden": []
  },
  {
    "id": "paperli-crawler",
    "category": "UNKNOWN",
    "name": "paperli-crawler",
    "patterns": [
      "PaperLiBot"
    ],
    "forbidden": []
  },
  {
    "id": "phxbot",
    "category": "UNKNOWN",
    "name": "phxbot",
    "patterns": [
      "PhxBot"
    ],
    "forbidden": []
  },
  {
    "id": "picsearch-crawler",
    "category": "UNKNOWN",
    "name": "picsearch-crawler",
    "patterns": [
      "psbot"
    ],
    "forbidden": []
  },
  {
    "id": "postrank-crawler",
    "category": "UNKNOWN",
    "name": "postrank-crawler",
    "patterns": [
      "postrank"
    ],
    "forbidden": []
  },
  {
    "id": "prcy-crawler",
    "category": "UNKNOWN",
    "name": "prcy-crawler",
    "patterns": [
      "PR-CY\\.RU"
    ],
    "forbidden": []
  },
  {
    "id": "privacore-crawler",
    "category": "UNKNOWN",
    "name": "privacore-crawler",
    "patterns": [
      "findxbot"
    ],
    "forbidden": []
  },
  {
    "id": "privacyaware-crawler",
    "category": "UNKNOWN",
    "name": "privacyaware-crawler",
    "patterns": [
      "PrivacyAwareBot"
    ],
    "forbidden": []
  },
  {
    "id": "profound-crawler",
    "category": "UNKNOWN",
    "name": "profound-crawler",
    "patterns": [
      "urlappendbot"
    ],
    "forbidden": []
  },
  {
    "id": "proximic-crawler",
    "category": "UNKNOWN",
    "name": "proximic-crawler",
    "patterns": [
      "proximic"
    ],
    "forbidden": []
  },
  {
    "id": "pulsepoint-crawler",
    "category": "UNKNOWN",
    "name": "pulsepoint-crawler",
    "patterns": [
      "Pulsepoint"
    ],
    "forbidden": []
  },
  {
    "id": "pure-crawler",
    "category": "UNKNOWN",
    "name": "pure-crawler",
    "patterns": [
      "purebot"
    ],
    "forbidden": []
  },
  {
    "id": "rankactive-crawler",
    "category": "UNKNOWN",
    "name": "rankactive-crawler",
    "patterns": [
      "RankActiveLinkBot"
    ],
    "forbidden": []
  },
  {
    "id": "retrevo-page-analyzer",
    "category": "UNKNOWN",
    "name": "retrevo-page-analyzer",
    "patterns": [
      "RetrevoPageAnalyzer"
    ],
    "forbidden": []
  },
  {
    "id": "ridder-crawler",
    "category": "UNKNOWN",
    "name": "ridder-crawler",
    "patterns": [
      "RidderBot"
    ],
    "forbidden": []
  },
  {
    "id": "rivva-crawler",
    "category": "UNKNOWN",
    "name": "rivva-crawler",
    "patterns": [
      "Rivva"
    ],
    "forbidden": []
  },
  {
    "id": "ryte-crawler",
    "category": "UNKNOWN",
    "name": "ryte-crawler",
    "patterns": [
      "RyteBot"
    ],
    "forbidden": []
  },
  {
    "id": "scan-interfax-crawler",
    "category": "UNKNOWN",
    "name": "scan-interfax-crawler",
    "patterns": [
      "InterfaxScanBot"
    ],
    "forbidden": []
  },
  {
    "id": "schmorp-crawler",
    "category": "UNKNOWN",
    "name": "schmorp-crawler",
    "patterns": [
      "AnyEvent"
    ],
    "forbidden": []
  },
  {
    "id": "scoutjet-crawler",
    "category": "UNKNOWN",
    "name": "scoutjet-crawler",
    "patterns": [
      "ScoutJet"
    ],
    "forbidden": []
  },
  {
    "id": "scribd-crawler",
    "category": "UNKNOWN",
    "name": "scribd-crawler",
    "patterns": [
      "scribdbot"
    ],
    "forbidden": []
  },
  {
    "id": "scritch-crawler",
    "category": "UNKNOWN",
    "name": "scritch-crawler",
    "patterns": [
      "Fetch\\/"
    ],
    "forbidden": []
  },
  {
    "id": "seekbot-crawler",
    "category": "UNKNOWN",
    "name": "seekbot-crawler",
    "patterns": [
      "seekbot"
    ],
    "forbidden": []
  },
  {
    "id": "seewithkids-crawler",
    "category": "UNKNOWN",
    "name": "seewithkids-crawler",
    "patterns": [
      "seewithkids"
    ],
    "forbidden": []
  },
  {
    "id": "semanticaudience-crawler",
    "category": "UNKNOWN",
    "name": "semanticaudience-crawler",
    "patterns": [
      "semanticbot"
    ],
    "forbidden": []
  },
  {
    "id": "sempitech-crawler",
    "category": "UNKNOWN",
    "name": "sempitech-crawler",
    "patterns": [
      "sempi\\.tech"
    ],
    "forbidden": []
  },
  {
    "id": "semrush-crawler",
    "category": "UNKNOWN",
    "name": "SemRushBot",
    "patterns": [
      "S[eE][mM]rushBot"
    ],
    "forbidden": []
  },
  {
    "id": "senuto-crawler",
    "category": "UNKNOWN",
    "name": "senuto-crawler",
    "patterns": [
      "SenutoBot"
    ],
    "forbidden": []
  },
  {
    "id": "seobility-crawler",
    "category": "UNKNOWN",
    "name": "seobility-crawler",
    "patterns": [
      "SeobilityBot"
    ],
    "forbidden": []
  },
  {
    "id": "seokicks-crawler",
    "category": "UNKNOWN",
    "name": "seokicks-crawler",
    "patterns": [
      "SEOkicks"
    ],
    "forbidden": []
  },
  {
    "id": "seolizer-crawler",
    "category": "UNKNOWN",
    "name": "seolizer-crawler",
    "patterns": [
      "SEOlizer"
    ],
    "forbidden": []
  },
  {
    "id": "seoprofiler-crawler",
    "category": "UNKNOWN",
    "name": "seoprofiler-crawler",
    "patterns": [
      "spbot"
    ],
    "forbidden": []
  },
  {
    "id": "seoscanners-crawler",
    "category": "UNKNOWN",
    "name": "seoscanners-crawler",
    "patterns": [
      "seoscanners"
    ],
    "forbidden": []
  },
  {
    "id": "seostar-crawler",
    "category": "UNKNOWN",
    "name": "seostar-crawler",
    "patterns": [
      "seostar\\.co"
    ],
    "forbidden": []
  },
  {
    "id": "seozoom-crawler",
    "category": "UNKNOWN",
    "name": "ZoomBot",
    "patterns": [
      "ZoomBot"
    ],
    "forbidden": []
  },
  {
    "id": "serpstatbot-crawler",
    "category": "UNKNOWN",
    "name": "serpstatbot-crawler",
    "patterns": [
      "serpstatbot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "seznam-crawler",
    "category": "UNKNOWN",
    "name": "seznam-crawler",
    "patterns": [
      "SeznamBot"
    ],
    "forbidden": []
  },
  {
    "id": "similartech-crawler",
    "category": "UNKNOWN",
    "name": "similartech-crawler",
    "patterns": [
      "smtbot"
    ],
    "forbidden": []
  },
  {
    "id": "simple-crawler",
    "category": "UNKNOWN",
    "name": "simple-crawler",
    "patterns": [
      "SimpleCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "sistrix-007ac9-crawler",
    "category": "UNKNOWN",
    "name": "sistrix-007ac9-crawler",
    "patterns": [
      "007ac9 Crawler"
    ],
    "forbidden": []
  },
  {
    "id": "sitebot-crawler",
    "category": "UNKNOWN",
    "name": "sitebot-crawler",
    "patterns": [
      "sitebot"
    ],
    "forbidden": []
  },
  {
    "id": "sitechecker-crawler",
    "category": "UNKNOWN",
    "name": "sitechecker-crawler",
    "patterns": [
      "SiteCheckerBotCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "siteexplorer-crawler",
    "category": "UNKNOWN",
    "name": "siteexplorer-crawler",
    "patterns": [
      "siteexplorer\\.info"
    ],
    "forbidden": []
  },
  {
    "id": "siteimprove-crawler",
    "category": "UNKNOWN",
    "name": "siteimprove-crawler",
    "patterns": [
      "Siteimprove\\.com"
    ],
    "forbidden": []
  },
  {
    "id": "socialrank-crawler",
    "category": "UNKNOWN",
    "name": "socialrank-crawler",
    "patterns": [
      "SocialRankIOBot"
    ],
    "forbidden": []
  },
  {
    "id": "softbytelabs-crawler",
    "category": "UNKNOWN",
    "name": "softbytelabs-crawler",
    "patterns": [
      "SBL-BOT"
    ],
    "forbidden": []
  },
  {
    "id": "sogou-crawler",
    "category": "UNKNOWN",
    "name": "sogou-crawler",
    "patterns": [
      "Sogou"
    ],
    "forbidden": []
  },
  {
    "id": "stuttgart-crawler",
    "category": "UNKNOWN",
    "name": "stuttgart-crawler",
    "patterns": [
      "RegionStuttgartBot"
    ],
    "forbidden": []
  },
  {
    "id": "summify-crawler",
    "category": "UNKNOWN",
    "name": "summify-crawler",
    "patterns": [
      "summify"
    ],
    "forbidden": []
  },
  {
    "id": "swimgbot",
    "category": "UNKNOWN",
    "name": "swimgbot",
    "patterns": [
      "SWIMGBot"
    ],
    "forbidden": []
  },
  {
    "id": "sysomos-crawler",
    "category": "UNKNOWN",
    "name": "sysomos-crawler",
    "patterns": [
      "Sysomos"
    ],
    "forbidden": []
  },
  {
    "id": "t3versions-crawler",
    "category": "UNKNOWN",
    "name": "t3versions-crawler",
    "patterns": [
      "t3versionsBot"
    ],
    "forbidden": []
  },
  {
    "id": "taboola-crawler",
    "category": "UNKNOWN",
    "name": "taboola-crawler",
    "patterns": [
      "Taboolabot"
    ],
    "forbidden": []
  },
  {
    "id": "tagoo-crawler",
    "category": "UNKNOWN",
    "name": "tagoo-crawler",
    "patterns": [
      "tagoobot"
    ],
    "forbidden": []
  },
  {
    "id": "tangiblee-crawler",
    "category": "UNKNOWN",
    "name": "tangiblee-crawler",
    "patterns": [
      "TangibleeBot"
    ],
    "forbidden": []
  },
  {
    "id": "thinklab-crawler",
    "category": "UNKNOWN",
    "name": "thinklab-crawler",
    "patterns": [
      "Thinklab"
    ],
    "forbidden": []
  },
  {
    "id": "tiger-crawler",
    "category": "UNKNOWN",
    "name": "tiger-crawler",
    "patterns": [
      "tigerbot"
    ],
    "forbidden": []
  },
  {
    "id": "tineye-crawler",
    "category": "UNKNOWN",
    "name": "tineye-crawler",
    "patterns": [
      "TinEye"
    ],
    "forbidden": []
  },
  {
    "id": "tiscali-crawler",
    "category": "UNKNOWN",
    "name": "tiscali-crawler",
    "patterns": [
      "IstellaBot"
    ],
    "forbidden": []
  },
  {
    "id": "tombascraper-crawler",
    "category": "UNKNOWN",
    "name": "tombascraper-crawler",
    "patterns": [
      "TombaPublicWebCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "toplist-crawler",
    "category": "UNKNOWN",
    "name": "toplist-crawler",
    "patterns": [
      "toplistbot"
    ],
    "forbidden": []
  },
  {
    "id": "torus-crawler",
    "category": "UNKNOWN",
    "name": "torus-crawler",
    "patterns": [
      "ReverseEngineeringBot"
    ],
    "forbidden": []
  },
  {
    "id": "toutiao-crawler",
    "category": "UNKNOWN",
    "name": "toutiao-crawler",
    "patterns": [
      "ToutiaoSpider"
    ],
    "forbidden": []
  },
  {
    "id": "traackr-crawler",
    "category": "UNKNOWN",
    "name": "traackr-crawler",
    "patterns": [
      "Traackr\\.com"
    ],
    "forbidden": []
  },
  {
    "id": "tracemyfile-crawler",
    "category": "UNKNOWN",
    "name": "tracemyfile-crawler",
    "patterns": [
      "tracemyfile"
    ],
    "forbidden": []
  },
  {
    "id": "trendiction-crawler",
    "category": "UNKNOWN",
    "name": "trendiction-crawler",
    "patterns": [
      "trendictionbot"
    ],
    "forbidden": []
  },
  {
    "id": "trove-crawler",
    "category": "UNKNOWN",
    "name": "trove-crawler",
    "patterns": [
      "Trove"
    ],
    "forbidden": []
  },
  {
    "id": "trovit-crawler",
    "category": "UNKNOWN",
    "name": "trovit-crawler",
    "patterns": [
      "trovitBot"
    ],
    "forbidden": []
  },
  {
    "id": "tweetmemebot",
    "category": "UNKNOWN",
    "name": "tweetmemebot",
    "patterns": [
      "TweetmemeBot"
    ],
    "forbidden": []
  },
  {
    "id": "twenga-crawler",
    "category": "UNKNOWN",
    "name": "twenga-crawler",
    "patterns": [
      "twengabot"
    ],
    "forbidden": []
  },
  {
    "id": "twingly-crawler",
    "category": "UNKNOWN",
    "name": "twingly-crawler",
    "patterns": [
      "Twingly"
    ],
    "forbidden": []
  },
  {
    "id": "twoip-crawler",
    "category": "UNKNOWN",
    "name": "twoip-crawler",
    "patterns": [
      "2ip bot"
    ],
    "forbidden": []
  },
  {
    "id": "twoip-crawler-cms",
    "category": "UNKNOWN",
    "name": "twoip-crawler-cms",
    "patterns": [
      "2ip\\.ru"
    ],
    "forbidden": []
  },
  {
    "id": "twurly-crawler",
    "category": "UNKNOWN",
    "name": "twurly-crawler",
    "patterns": [
      "Twurly"
    ],
    "forbidden": []
  },
  {
    "id": "ubermetrics-crawler",
    "category": "UNKNOWN",
    "name": "ubermetrics-crawler",
    "patterns": [
      "um-LN"
    ],
    "forbidden": []
  },
  {
    "id": "ubt-crawler",
    "category": "UNKNOWN",
    "name": "ubt-crawler",
    "patterns": [
      "Streamline3Bot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "upflow-crawler",
    "category": "UNKNOWN",
    "name": "upflow-crawler",
    "patterns": [
      "Upflow"
    ],
    "forbidden": []
  },
  {
    "id": "urlclassification-crawler",
    "category": "UNKNOWN",
    "name": "urlclassification-crawler",
    "patterns": [
      "KStandBot"
    ],
    "forbidden": []
  },
  {
    "id": "usine-nouvelle-crawler",
    "category": "UNKNOWN",
    "name": "usine-nouvelle-crawler",
    "patterns": [
      "UsineNouvelleCrawler"
    ],
    "forbidden": []
  },
  {
    "id": "utorrent-crawler",
    "category": "UNKNOWN",
    "name": "utorrent-crawler",
    "patterns": [
      "BTWebClient"
    ],
    "forbidden": []
  },
  {
    "id": "vebidoo-crawler",
    "category": "UNKNOWN",
    "name": "vebidoo-crawler",
    "patterns": [
      "vebidoobot"
    ],
    "forbidden": []
  },
  {
    "id": "veooz-crawler",
    "category": "UNKNOWN",
    "name": "veooz-crawler",
    "patterns": [
      "Veoozbot"
    ],
    "forbidden": []
  },
  {
    "id": "verisign-ips-agent",
    "category": "UNKNOWN",
    "name": "verisign-ips-agent",
    "patterns": [
      "ips-agent"
    ],
    "forbidden": []
  },
  {
    "id": "vigil-crawler",
    "category": "UNKNOWN",
    "name": "vigil-crawler",
    "patterns": [
      "Vigil\\/"
    ],
    "forbidden": []
  },
  {
    "id": "vipnytt-crawler",
    "category": "UNKNOWN",
    "name": "vipnytt-crawler",
    "patterns": [
      "jpg-newsbot"
    ],
    "forbidden": []
  },
  {
    "id": "virustotal-crawler",
    "category": "UNKNOWN",
    "name": "virustotal-crawler",
    "patterns": [
      "virustotal"
    ],
    "forbidden": []
  },
  {
    "id": "vkrobot-crawler",
    "category": "UNKNOWN",
    "name": "vkrobot-crawler",
    "patterns": [
      "VKRobot"
    ],
    "forbidden": []
  },
  {
    "id": "vkshare-crawler",
    "category": "UNKNOWN",
    "name": "vkshare-crawler",
    "patterns": [
      "vkShare"
    ],
    "forbidden": []
  },
  {
    "id": "vuhuv-crawler",
    "category": "UNKNOWN",
    "name": "vuhuv-crawler",
    "patterns": [
      "vuhuvBot"
    ],
    "forbidden": []
  },
  {
    "id": "warebay-crawler",
    "category": "UNKNOWN",
    "name": "warebay-crawler",
    "patterns": [
      "wbsearchbot"
    ],
    "forbidden": []
  },
  {
    "id": "webceo-crawler",
    "category": "UNKNOWN",
    "name": "webceo-crawler",
    "patterns": [
      "online-webceo-bot"
    ],
    "forbidden": []
  },
  {
    "id": "webcompany-crawler",
    "category": "UNKNOWN",
    "name": "webcompany-crawler",
    "patterns": [
      "webcompanycrawler"
    ],
    "forbidden": []
  },
  {
    "id": "webdatastats-crawler",
    "category": "UNKNOWN",
    "name": "webdatastats-crawler",
    "patterns": [
      "WebDataStats"
    ],
    "forbidden": []
  },
  {
    "id": "webeaver-crawler",
    "category": "UNKNOWN",
    "name": "webeaver-crawler",
    "patterns": [
      "BehloolBot"
    ],
    "forbidden": []
  },
  {
    "id": "webmeup-crawler",
    "category": "UNKNOWN",
    "name": "webmeup-crawler",
    "patterns": [
      "BLEXBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "webmon",
    "category": "UNKNOWN",
    "name": "webmon",
    "patterns": [
      "webmon "
    ],
    "forbidden": []
  },
  {
    "id": "wesee-crawler",
    "category": "UNKNOWN",
    "name": "wesee-crawler",
    "patterns": [
      "WeSEE:Search"
    ],
    "forbidden": []
  },
  {
    "id": "wocodi-crawler",
    "category": "UNKNOWN",
    "name": "wocodi-crawler",
    "patterns": [
      "wocbot"
    ],
    "forbidden": []
  },
  {
    "id": "woorank-crawler",
    "category": "UNKNOWN",
    "name": "woorank-crawler",
    "patterns": [
      "woobot"
    ],
    "forbidden": []
  },
  {
    "id": "woorank-crawler-review",
    "category": "UNKNOWN",
    "name": "woorank-crawler-review",
    "patterns": [
      "woorankreview\\/"
    ],
    "forbidden": []
  },
  {
    "id": "wordpress-crawler",
    "category": "UNKNOWN",
    "name": "WordPressBot",
    "patterns": [
      "WordPress\\/"
    ],
    "forbidden": []
  },
  {
    "id": "wordup-crawler",
    "category": "UNKNOWN",
    "name": "wordup-crawler",
    "patterns": [
      "WordupInfoSearch"
    ],
    "forbidden": []
  },
  {
    "id": "worio-crawler",
    "category": "UNKNOWN",
    "name": "worio-crawler",
    "patterns": [
      "woriobot"
    ],
    "forbidden": []
  },
  {
    "id": "wotbox-crawler",
    "category": "UNKNOWN",
    "name": "wotbox-crawler",
    "patterns": [
      "wotbox"
    ],
    "forbidden": []
  },
  {
    "id": "xovibot-crawler",
    "category": "UNKNOWN",
    "name": "xovibot-crawler",
    "patterns": [
      "xovibot"
    ],
    "forbidden": []
  },
  {
    "id": "yanga-crawler",
    "category": "UNKNOWN",
    "name": "yanga-crawler",
    "patterns": [
      "yanga"
    ],
    "forbidden": []
  },
  {
    "id": "yellowbp-crawler",
    "category": "UNKNOWN",
    "name": "yellowbp-crawler",
    "patterns": [
      "Yellowbrandprotectionbot"
    ],
    "forbidden": []
  },
  {
    "id": "yisou-crawler",
    "category": "UNKNOWN",
    "name": "yisou-crawler",
    "patterns": [
      "YisouSpider"
    ],
    "forbidden": []
  },
  {
    "id": "yooz-crawler",
    "category": "UNKNOWN",
    "name": "yooz-crawler",
    "patterns": [
      "yoozBot"
    ],
    "forbidden": []
  },
  {
    "id": "zoominfo-crawler",
    "category": "UNKNOWN",
    "name": "zoominfo-crawler",
    "patterns": [
      "ZoominfoBot"
    ],
    "forbidden": []
  },
  {
    "id": "zum-crawler",
    "category": "UNKNOWN",
    "name": "ZumBot",
    "patterns": [
      "ZumBot"
    ],
    "forbidden": []
  },
  {
    "id": "zuperlist-crawler",
    "category": "UNKNOWN",
    "name": "zuperlist-crawler",
    "patterns": [
      "ZuperlistBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "ext-ahrefsbotsiteaudit",
    "name": "ahrefsbotsiteaudit",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "Ahrefs(Bot|SiteAudit)"
    ],
    "forbidden": []
  },
  {
    "id": "ext-amazonproductdiscovery",
    "name": "amazonproductdiscovery",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "AmazonProductDiscovery"
    ],
    "forbidden": []
  },
  {
    "id": "ext-amazonsellerinitiatedlisting",
    "name": "amazonsellerinitiatedlisting",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "AmazonSellerInitiatedListing"
    ],
    "forbidden": []
  },
  {
    "id": "ext-cclaudebbot",
    "name": "cclaudebbot",
    "category": "SCRAPER",
    "patterns": [
      "[cC]laude[bB]ot"
    ],
    "forbidden": []
  },
  {
    "id": "ext-meta-externalagent",
    "name": "meta-externalagent",
    "category": "SCRAPER",
    "patterns": [
      "meta-externalagent\\/"
    ],
    "forbidden": []
  },
  {
    "id": "ext-meta-externalfetcher",
    "name": "meta-externalfetcher",
    "category": "SCRAPER",
    "patterns": [
      "meta-externalfetcher\\/"
    ],
    "forbidden": []
  },
  {
    "id": "ext-hydrozenio",
    "name": "hydrozenio",
    "category": "MONITORING",
    "patterns": [
      "Hydrozen\\.io"
    ],
    "forbidden": []
  },
  {
    "id": "ext-yextbot",
    "name": "yextbot",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "YextBot\\/"
    ],
    "forbidden": []
  },
  {
    "id": "ext-datadogsynthetics",
    "name": "datadogsynthetics",
    "category": "MONITORING",
    "patterns": [
      "DatadogSynthetics"
    ],
    "forbidden": []
  },
  {
    "id": "ext-observepoint",
    "name": "observepoint",
    "category": "MONITORING",
    "patterns": [
      "ObservePoint"
    ],
    "forbidden": []
  },
  {
    "id": "ext-checkly",
    "name": "checkly",
    "category": "MONITORING",
    "patterns": [
      "Checkly"
    ],
    "forbidden": []
  },
  {
    "id": "ext-alittleclient",
    "name": "alittleclient",
    "category": "SCRAPER",
    "patterns": [
      "ALittle Client"
    ],
    "forbidden": []
  },
  {
    "id": "ext-aliyunsecbot",
    "name": "aliyunsecbot",
    "category": "SCRAPER",
    "patterns": [
      "AliyunSecBot"
    ],
    "forbidden": []
  },
  {
    "id": "ext-claude-web",
    "name": "claude-web",
    "category": "SCRAPER",
    "patterns": [
      "Claude-Web"
    ],
    "forbidden": []
  },
  {
    "id": "ext-google-extended",
    "name": "google-extended",
    "category": "SCRAPER",
    "patterns": [
      "Google-Extended"
    ],
    "forbidden": []
  },
  {
    "id": "ext-serankingbacklinksbot",
    "name": "serankingbacklinksbot",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "SERankingBacklinksBot"
    ],
    "forbidden": []
  },
  {
    "id": "ext-cmschecker",
    "name": "cmschecker",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "CMSChecker"
    ],
    "forbidden": []
  },
  {
    "id": "ext-wayback",
    "name": "wayback",
    "category": "SCRAPER",
    "patterns": [
      "Wayback"
    ],
    "forbidden": []
  },
  {
    "id": "ext-playwright",
    "name": "playwright",
    "category": "SCRAPER",
    "patterns": [
      "Playwright"
    ],
    "forbidden": []
  },
  {
    "id": "ext-puppeteer",
    "name": "puppeteer",
    "category": "SCRAPER",
    "patterns": [
      "Puppeteer"
    ],
    "forbidden": []
  },
  {
    "id": "ext-selenium",
    "name": "selenium",
    "category": "SCRAPER",
    "patterns": [
      "Selenium"
    ],
    "forbidden": []
  },
  {
    "id": "ext-nikto",
    "name": "nikto",
    "category": "SECURITY_SCANNER",
    "patterns": [
      "Nikto"
    ],
    "forbidden": []
  },
  {
    "id": "ext-sqlmap",
    "name": "sqlmap",
    "category": "SECURITY_SCANNER",
    "patterns": [
      "sqlmap"
    ],
    "forbidden": []
  },
  {
    "id": "ext-zmeu",
    "name": "zmeu",
    "category": "SECURITY_SCANNER",
    "patterns": [
      "ZmEu"
    ],
    "forbidden": []
  },
  {
    "id": "ext-masscan",
    "name": "masscan",
    "category": "SECURITY_SCANNER",
    "patterns": [
      "masscan"
    ],
    "forbidden": []
  },
  {
    "id": "ext-wpscan",
    "name": "wpscan",
    "category": "SECURITY_SCANNER",
    "patterns": [
      "WPScan"
    ],
    "forbidden": []
  },
  {
    "id": "ext-aacunetix",
    "name": "aacunetix",
    "category": "SECURITY_SCANNER",
    "patterns": [
      "[aA]cunetix"
    ],
    "forbidden": []
  },
  {
    "id": "ext-nessus",
    "name": "nessus",
    "category": "SECURITY_SCANNER",
    "patterns": [
      "Nessus"
    ],
    "forbidden": []
  },
  {
    "id": "ext-ddirbbuster",
    "name": "ddirbbuster",
    "category": "SECURITY_SCANNER",
    "patterns": [
      "[dD]ir[Bb]uster"
    ],
    "forbidden": []
  },
  {
    "id": "ext-colly",
    "name": "colly",
    "category": "SCRAPER",
    "patterns": [
      "colly"
    ],
    "forbidden": []
  },
  {
    "id": "ext-mmechanize",
    "name": "mmechanize",
    "category": "SCRAPER",
    "patterns": [
      "[mM]echanize"
    ],
    "forbidden": []
  },
  {
    "id": "ext-airaiscanning",
    "name": "airaiscanning",
    "category": "SCRAPER",
    "patterns": [
      "air\\.ai\\/scanning"
    ],
    "forbidden": []
  },
  {
    "id": "ext-asnriskscorer",
    "name": "asnriskscorer",
    "category": "SCRAPER",
    "patterns": [
      "asnriskscorer"
    ],
    "forbidden": []
  },
  {
    "id": "ext-oicrawler",
    "name": "oicrawler",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "OICrawler"
    ],
    "forbidden": []
  },
  {
    "id": "ext-l9scan",
    "name": "l9scan",
    "category": "SECURITY_SCANNER",
    "patterns": [
      "l9scan"
    ],
    "forbidden": []
  },
  {
    "id": "ext-slaccalebot",
    "name": "slaccalebot",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "SlaccaleBot"
    ],
    "forbidden": []
  },
  {
    "id": "ext-customasynchttpclient",
    "name": "customasynchttpclient",
    "category": "SCRAPER",
    "patterns": [
      "CustomAsyncHttpClient"
    ],
    "forbidden": []
  },
  {
    "id": "ext-gemini-deep-research",
    "name": "gemini-deep-research",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "Gemini-Deep-Research"
    ],
    "forbidden": []
  },
  {
    "id": "ext-perplexity-user",
    "name": "perplexity-user",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "Perplexity-User"
    ],
    "forbidden": []
  },
  {
    "id": "ext-perplexityuser",
    "name": "perplexityuser",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "PerplexityUser"
    ],
    "forbidden": []
  },
  {
    "id": "ext-meta-webindexer",
    "name": "meta-webindexer",
    "category": "SCRAPER",
    "patterns": [
      "meta-webindexer"
    ],
    "forbidden": []
  },
  {
    "id": "ext-duckassistbot",
    "name": "duckassistbot",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "DuckAssistBot"
    ],
    "forbidden": []
  },
  {
    "id": "ext-mistralai-user",
    "name": "mistralai-user",
    "category": "SCRAPER",
    "patterns": [
      "MistralAI-User"
    ],
    "forbidden": []
  },
  {
    "id": "ext-webzio",
    "name": "webzio",
    "category": "SEARCH_ENGINE",
    "patterns": [
      "webzio"
    ],
    "forbidden": []
  },
  {
    "id": "ext-newsai",
    "name": "newsai",
    "category": "SCRAPER",
    "patterns": [
      "newsai\\/"
    ],
    "forbidden": []
  },
  {
    "id": "arcis-nuclei",
    "category": "SECURITY_SCANNER",
    "name": "nuclei",
    "patterns": [
      "Nuclei"
    ],
    "forbidden": []
  },
  {
    "id": "ext-openvas",
    "category": "SECURITY_SCANNER",
    "name": "openvas",
    "patterns": [
      "OpenVAS"
    ],
    "forbidden": []
  },
  {
    "id": "ext-ffuf",
    "category": "SECURITY_SCANNER",
    "name": "ffuf",
    "patterns": [
      "Fuzz Faster U Fool"
    ],
    "forbidden": []
  },
  {
    "id": "ext-nasl",
    "category": "SECURITY_SCANNER",
    "name": "nasl",
    "patterns": [
      ".nasl"
    ],
    "forbidden": []
  },
  {
    "id": "ext-feroxbuster",
    "category": "SECURITY_SCANNER",
    "name": "feroxbuster",
    "patterns": [
      "feroxbuster"
    ],
    "forbidden": []
  },
  {
    "id": "ext-gobuster",
    "category": "SECURITY_SCANNER",
    "name": "gobuster",
    "patterns": [
      "gobuster"
    ],
    "forbidden": []
  },
  {
    "id": "ext-arachni",
    "category": "SECURITY_SCANNER",
    "name": "arachni",
    "patterns": [
      "Arachni"
    ],
    "forbidden": []
  },
  {
    "id": "ext-w3af",
    "category": "SECURITY_SCANNER",
    "name": "w3af",
    "patterns": [
      "w3af"
    ],
    "forbidden": []
  },
  {
    "id": "ext-skipfish",
    "category": "SECURITY_SCANNER",
    "name": "skipfish",
    "patterns": [
      "skipfish"
    ],
    "forbidden": []
  },
  {
    "id": "ext-netsparker",
    "category": "SECURITY_SCANNER",
    "name": "netsparker",
    "patterns": [
      "Netsparker"
    ],
    "forbidden": []
  },
  {
    "id": "ext-whatweb",
    "category": "SECURITY_SCANNER",
    "name": "whatweb",
    "patterns": [
      "WhatWeb"
    ],
    "forbidden": []
  },
  {
    "id": "ext-wfuzz",
    "category": "SECURITY_SCANNER",
    "name": "wfuzz",
    "patterns": [
      "Wfuzz"
    ],
    "forbidden": []
  },
  {
    "id": "ext-qualys",
    "category": "SECURITY_SCANNER",
    "name": "qualys",
    "patterns": [
      "Qualys"
    ],
    "forbidden": []
  }
]